(function () {
  'use strict';

  angular
    .module('respondentClient', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'angularCSS',
      'pascalprecht.translate',
      'LocalStorageModule',
      'duScroll',
      'ipCookie',
      'toaster',
      'angularAwesomeSlider',
      'as.sortable',
      'angular.css.injector',
      'siyfion.sfTypeahead'
    ]
  );
})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.directive('questionUniqueChoice', questionUniqueChoice);

	function questionUniqueChoice() {
		var directive = {
			bindToController: true,
			controller: 'UniqueChoiceController',
			controllerAs: 'vm',
			replace: true,
			restrict: 'E',
			scope: {
				element: '='
			},
			templateUrl: 'app/views/directives/questionnaire/elements/questions/unique-choice.html',
			transclude: true
		};

		return directive;
	}
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('questionScaleTrainer', function () {
      return {
        restrict: 'E',
        scope: {
          element: '=',
          options: '='
        },
        replace: true,
        transclude: true,
        templateUrl: "app/views/directives/questionnaire/elements/questions/scale-trainer.html",
        controller: scaleTrainersController,
        controllerAs: 'vm',
        bindToController: true
      };

      function scaleTrainersController() {
        var vm = this;

        vm.parameters = null;
        vm.sliderOptions = [];

        __initQuestion();

        function __initStepsArray() {
          var returnArray = [];
          angular.forEach(vm.element.data.objects[1].data.objects, function (value) {
            returnArray.push({val: value.data.degree, label: value.data.index});
          });
          return returnArray;
        }

        function __initQuestion() {
          vm.questionData = [];
          vm.trainers = [];
          angular.forEach(vm.element.data.objects, function (value) {
            switch (value.type) {
                case 'parameter' :
                    vm.parameters = value.data;
                break;
              case 'scale' :
                vm.scale = value.data;
                break;
              case 'trainer' :
              case 'trainingOrganization' :
                vm.questionData.push(value.data);
                break;
            }
          });

          /**
           * construire l'objet des options pour la directive slider
           */
          angular.forEach(vm.questionData,function(ele){
              vm.sliderOptions[ele.id]= {
                  model : (vm.element.response != null && angular.isDefined(vm.element.response[ele.id])) ? vm.element.response[ele.id] : -1,
                  type: 'scale',
                  id: ele.id ,
                  from: vm.element.data.objects[1].data.objects[0].data.degree,
                  to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.degree,
                  labels: [
                      vm.element.data.objects[1].data.objects[0].data.title,
                      vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
                  ],
                  scales: __initStepsArray()
              };

          });

          /**
           * inialiser et regarder si la question à des réponse déja
           */

          if (vm.element.response != null && (Object.keys(vm.element.response).length == vm.trainers.length)) {
            vm.element.haveChoiceResponse = true;
          } else {
            vm.element.haveChoiceResponse = false;
          }

        }

      }

    });
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('questionScaleSequence', function () {
      return {
        restrict: 'E',
        scope: {
          element: '=',
          options: '='
        },
        replace: true,
        transclude: true,
        templateUrl: "app/views/directives/questionnaire/elements/questions/scale-sequence.html",
        controller: scaleSequenceController,
        controllerAs: 'vm',
        bindToController: true
      };
      function scaleSequenceController() {
        var vm = this;

        vm.parameters = null;
        vm.sliderOptions = [];

        __initQuestion();

        function __initStepsArray() {
          var returnArray = [];
          angular.forEach(vm.element.data.objects[1].data.objects, function (value) {
            returnArray.push({val: value.data.degree, label: value.data.index});
          });
          return returnArray;
        }

        function __initQuestion() {

          vm.questionData = [];
          vm.sequences = [];

          angular.forEach(vm.element.data.objects, function (value) {
            switch (value.type) {
              case 'parameter' :
                vm.parameters = value.data;
                break;
              case 'scale' :
                vm.scale = value.data;
                break;
              case 'sequence' :
                vm.questionData.push(value.data);
                break;
            }
          });

            /**
             * construire l'objet des options pour la directive slider
             */
            angular.forEach(vm.questionData,function(ele){
                vm.sliderOptions[ele.id]= {
                    model : (vm.element.response != null && angular.isDefined(vm.element.response[ele.id])) ? vm.element.response[ele.id] : -1,
                    type: 'scale',
                    id: ele.id ,
                    from: vm.element.data.objects[1].data.objects[0].data.index,
                    to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.index,
                    labels: [
                        vm.element.data.objects[1].data.objects[0].data.title,
                        vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
                    ],
                    scales: __initStepsArray()
                };

            });

          /**
           * inialiser et regarder si la question à des réponse déja
           */

          if(vm.element.response != null && (Object.keys(vm.element.response).length  == vm.sequences.length)) {
            vm.element.haveChoiceResponse = true;
          } else {
            vm.element.haveChoiceResponse = false;
          }

        }

      }

    });
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('questionScaleObjectives', function () {

      return {
        restrict: 'E',
        scope: {
          element: '=',
          options: '='
        },
        replace: true,
        transclude: true,
        templateUrl: "app/views/directives/questionnaire/elements/questions/scale-objectives.html",
        controller: scaleObjectivesController,
        controllerAs: 'vm',
        bindToController: true
      };

      function scaleObjectivesController() {
        var vm = this;

        vm.parameters = null;
        vm.sliderOptions = [];

        __initQuestion();
        function __initStepsArray () {
          var returnArray = [];
          angular.forEach(vm.element.data.objects[1].data.objects, function (value) {
            returnArray.push({val: value.data.degree, label: value.data.index});
          });
          return returnArray;
        }

        function __initQuestion() {
          vm.questionData = [];
          vm.objectives =[];




          angular.forEach(vm.element.data.objects, function (value) {


            /* si la scale n'a pas d'echelle alors checkScaleIsnull true*/
            angular.forEach(value.data.objects, function (value) {

            if(value.data.index==null){
              vm.element.data.checkScaleisNull = true;


            }
            });
            switch (value.type) {
              case 'parameter' :
                vm.parameters = value.data;
                break;
              case 'scale' :
                vm.scale = value.data;
                break;
              case 'commitment':
              case 'objective':
                vm.questionData.push(value.data);
            }
          });

          /**
           * construire l'objet des options pour la directive slider
           */
          angular.forEach(vm.questionData,function(ele){
              vm.sliderOptions[ele.id]= {
                model : (vm.element.response != null && angular.isDefined(vm.element.response[ele.id])) ? vm.element.response[ele.id] : -1,
                type: 'scale',
                id: ele.id ,
                from: vm.element.data.objects[1].data.objects[0].data.degree,
                to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.degree,
                labels: [
                  vm.element.data.objects[1].data.objects[0].data.title,
                  vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
                ],
                scales: __initStepsArray()
              };


          });







          /**
           * inialiser et regarder si la question à des réponse déja
           */




          if (vm.element.response != null && (Object.keys(vm.element.response).length  == vm.questionData.length)) {
            vm.element.haveChoiceResponse = true;
          } else {
            vm.element.haveChoiceResponse = false;
          }



          /* a supprimer test*/
          if( vm.element.data.checkScaleisNull ){

          var tab = new Array();
            angular.forEach(vm.questionData, function (value) {
                   tab.push(value.id);

            });

            var obj = {}
            tab.forEach(function(data) {
                obj[data] = true;
            })


            vm.element.doesntAnswerInputChecked=obj;


          }


        }

      }

    });
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('questionScaleObjectivesBeforeAfter', function () {

      return {
        restrict: 'E',
        scope: {
          element: '=',
          options: '='
        },
        templateUrl: "app/views/directives/questionnaire/elements/questions/scale-objectives-before-after.html",
        controller: scaleObjectivesBeforeAfterController,
        controllerAs: 'vm',
        bindToController: true
      };

      function scaleObjectivesBeforeAfterController() {
        var vm = this;

        vm.parameters = null;
        vm.sliderOptions = [];

        __initQuestion();

        function __initStepsArray () {
          var returnArray = [];
          angular.forEach(vm.element.data.objects[1].data.objects, function (value) {
            returnArray.push({val: value.data.degree, label: value.data.index});
          });
          return returnArray;
        }

        function __initQuestion() {
          vm.objectives =[];
          vm.nonActivable = vm.element.data.objects[0].data.nonActivable;
          vm.nonActivableLabel = vm.element.data.objects[0].data.nonActivableLabel;
          vm.commentable = vm.element.data.objects[0].data.commentable;
          vm.questionId = vm.element.data.id;
          vm.element.showDoesNotAnswerByScale = false;
          vm.element.showCommentByScale = false;

          angular.forEach(vm.element.data.objects, function (value) {
            switch (value.type) {
              case 'parameter' :
                vm.parameters = value.data;
                break;
              case 'scale' :
                vm.scale = value.data;
                break;
              case 'objective':
                vm.objectives.push(value.data);
            }
          });

          /**
           * construire l'objet des options pour la directive slider
           */

          angular.forEach(vm.objectives,function(objective){

            vm.sliderOptions[objective.id] = [];

            vm.sliderOptions[objective.id]['before'] = {
              model: (vm.element.response != null && vm.element.response[objective.id + '-before'] != undefined) ? vm.element.response[objective.id + '-before'] : -1,
              type: 'scale',
              id: objective.id + '-before',
              from: vm.element.data.objects[1].data.objects[0].data.degree,
              to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.degree,
              labels: [
                vm.element.data.objects[1].data.objects[0].data.title,
                vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
              ],
              scales: __initStepsArray()
            };

            vm.sliderOptions[objective.id]['after']   = {
              model : (vm.element.response != null && vm.element.response[objective.id + '-after'] != undefined) ? vm.element.response[objective.id + '-after'] : -1,
              type: 'scale',
              id: objective.id + '-after',
              from: vm.element.data.objects[1].data.objects[0].data.degree,
              to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.degree,
              labels: [
                vm.element.data.objects[1].data.objects[0].data.title,
                vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
              ],
              scales: __initStepsArray()
            };

          });

          /**
           * inialiser et regarder si la question à des réponse déja
           */
          if (vm.element.response != null && (Object.keys(vm.element.response).length  == (vm.objectives.length) * 2)) {
            vm.element.haveChoiceResponse = true;
          } else {
            vm.element.haveChoiceResponse = false;
          }
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .directive('questionScaleBeforeAfter', function () {
      return {
        restrict: 'E',
        scope: {
          element: '=',
          options: '='
        },
        templateUrl: "app/views/directives/questionnaire/elements/questions/scale-before-after.html",
        controller: scaleBeforeAfterController,
        controllerAs: 'vm',
        bindToController: true
      };


      function scaleBeforeAfterController($scope) {
        var vm = this;

        __initialize();

        function __initStepsArray() {
          var returnArray = [];

          angular.forEach(vm.element.data.objects[1].data.objects, function (value) {
            returnArray.push({val: value.data.degree, label: value.data.index});
          });

          return returnArray;
        }

        function __initialize() {
          vm.parameters = null;

          angular.forEach(vm.element.data.objects, function (value) {
            switch (value.type) {
              case 'parameter' :
                vm.parameters = value.data;
                break;
              case 'scale' :
                vm.scale = value.data;
                break;
            }
          });

          if (vm.element.response != null && vm.element.response[vm.element.data.id + '-before'] != undefined && vm.element.response[vm.element.data.id + '-after'] != undefined) {
            vm.element.haveChoiceResponse = true;
          } else {
            vm.element.haveChoiceResponse = false;
          }

          vm.sliderOptionsBefore = {
            model: (vm.element.response != null && vm.element.response[vm.element.data.id  + '-before'] != undefined) ? vm.element.response[vm.element.data.id + '-before'] : -1,
            type: 'scale',
            id: vm.element.data.id + '-before',
            from: vm.element.data.objects[1].data.objects[0].data.degree,
            to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.degree,
            labels: [
              vm.element.data.objects[1].data.objects[0].data.title,
              vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
            ],
            scales: __initStepsArray()
          };

          vm.sliderOptionsAfter = {
            model: (vm.element.response != null && vm.element.response[vm.element.data.id  + '-after'] != undefined) ? vm.element.response[vm.element.data.id + '-after'] : -1,
            type: 'scale',
            id: vm.element.data.id + '-after',
            from: vm.element.data.objects[1].data.objects[0].data.degree,
            to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.degree,
            labels: [
              vm.element.data.objects[1].data.objects[0].data.title,
              vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
            ],
            scales: __initStepsArray()
          };
        }

        /**
         * TODO adapter au cas deux sliders à watcher
         */
        $scope.$watch('vm.element.response', function (items) {
          if (items !== null) {
            if (vm.element.response != undefined && Object.keys(vm.element.response).length == 2 && vm.element.validator.isValid == false) {
              vm.element.haveChoiceResponse = true;
              vm.element = questionValidationFactory.validateScale(vm.element);
            }
          }
        }, true);
      }
    })
})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.directive('questionScale', questionScale);

	function questionScale() {
		var directive = {
			restrict: 'E',
			scope: {
				element: '='
			},
			templateUrl: 'app/views/directives/questionnaire/elements/questions/scale.html',
			controller: scaleController,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;

		function scaleController() {
			var vm = this;

			__initQuestion();

			function __initStepsArray () {
				var returnArray = [];
				angular.forEach(vm.element.data.objects[1].data.objects, function (value) {
                    returnArray.push({val: (value.data.degree), label: value.data.index});
				});

				return returnArray;
			}

			function __initQuestion() {
				vm.parameters = null;

				angular.forEach(vm.element.data.objects, function (value) {
					switch (value.type) {
						case 'parameter' :
							vm.parameters = value.data;
							break;
						case 'scale' :
							vm.scale = value.data;
							break;
					}
				});

				vm.sliderOptions = {
					model: (vm.element.response != undefined && vm.element.response != -1 && vm.element.response[vm.element.data.id] != undefined) ? vm.element.response[vm.element.data.id] : -1,
                    type: 'scale',
					id: vm.element.data.id,
					//from: vm.element.data.objects[1].data.objects[0].data.index,
					//to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.index,
                    from: vm.element.data.objects[1].data.objects[0].data.degree,
                    to: vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.degree,
                    labels: [
						vm.element.data.objects[1].data.objects[0].data.title,
						vm.element.data.objects[1].data.objects[vm.element.data.objects[1].data.objects.length - 1].data.title
					],
					scales: __initStepsArray()
				};
			}
		}
	}
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('questionQuizz', function () {
      return {
        restrict: 'E',
        scope: {
          element: '='
        },
        replace: true,
        transclude: true,
        templateUrl: "app/views/directives/questionnaire/elements/questions/quizz.html",
        controller: quizzController,
        controllerAs: 'vm',
        bindToController: true

      }
      function quizzController() {
        var vm = this;
        vm.choices = [];
        vm.parameters = null;
        initQuestion();

        function initQuestion() {
          angular.forEach(vm.element.data.objects, function (value) {
            switch (value.type) {
              case 'choice' :
                vm.choices.push(value.data);
                break;
              case 'parameter' :
                vm.parameters = value.data;
                break;
            }
          });
        }

      }

    });
})();

(function() {
    'use strict';

    angular
        .module('respondentClient')
        .directive('questionPreference', function(ToolsFactory, $filter) {
            return {
                restrict: 'E',
                scope: {
                    element: '='
                },
                replace: false,
                transclude: false,
                templateUrl: 'app/views/directives/questionnaire/elements/questions/preference.html',
                controller: preferenceController,
                controllerAs: 'vm',
                bindToController: true
            };

            function preferenceController($scope) {
                var vm = this;
                var firstTime = true;

                __initialize();

                function __initialize() {
                    vm.questionId = vm.element.data.id;
                    vm.element.preValidate = preValidate;
                    vm.choices = $filter('filter')(vm.element.data.objects, {type: 'choice'});
                    vm.element.response = ToolsFactory.randomizeObjects(vm.choices);

                    vm.choiceSortOptions = {
                        accept: accept
                    };

                }

                function accept(source, destination) {
                    return source.itemScope.sortableScope.$parent.vm.element.$$hashKey === destination.$parent.vm.element.$$hashKey;
                }

                $scope.$watch('vm.choices', function (model) {
                    vm.element.response = model;
                }, true);

                /**
                 *	Évite le déclenchement de $watch sur la réponse lorsque l'on
                 *	y affecte les choix la première fois
                 * (afin que la réponse ne soit pas valider même si le répondant n'a rien modifié)
                 */
                function preValidate() {
                    if (firstTime === true) {
                        firstTime = false;

                        return  {
                            goNext: false
                        };
                    }

                    return {
                        goNext: true
                    };
                }
            }
        });

})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.directive('questionOrderedResponse', function (ToolsFactory, $filter) {
      return {
        restrict: 'E',
        scope: {
          element: '='
        },
        replace: false,
        transclude: false,
        templateUrl: 'app/views/directives/questionnaire/elements/questions/ordered-response.html',
        controller: orderedResponseController,
        controllerAs: 'vm',
        bindToController: true
      };

      function orderedResponseController($scope) {
        var vm = this;
        var firstTime = true;

        __initialize();

        function __initialize() {
          vm.questionId = vm.element.data.id;
          vm.element.preValidate = preValidate;
          vm.choices = $filter('filter')(vm.element.data.objects, {type: 'choice'});
          vm.element.response = ToolsFactory.randomizeObjects(vm.choices);

          vm.choiceSortOptions = {
            accept: accept
          };

        }

        function accept(source, destination) {
          return source.itemScope.sortableScope.$parent.vm.element.$$hashKey === destination.$parent.vm.element.$$hashKey;
        }

        $scope.$watch('vm.choices', function (model) {
          vm.element.response = model;
        }, true);

        /**
         *	Évite le déclenchement de $watch sur la réponse lorsque l'on
         *	y affecte les choix la première fois
         * (afin que la réponse ne soit pas valider même si le répondant n'a rien modifié)
         */
        function preValidate() {
          if (firstTime === true) {
            firstTime = false;

            return  {
              goNext: false
            };
          }

          return {
            goNext: true
          };
        }
      }
    });

})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.directive('questionMultipleChoice', questionMultipleChoice);

	function questionMultipleChoice() {
		var directive = {
			restrict: 'E',
			scope: {
				element: '='
			},
			replace: true,
			transclude: true,
			templateUrl: 'app/views/directives/questionnaire/elements/questions/multi-choice.html',
			controller: multipleChoiceController,
			controllerAs: 'vm',
			bindToController: true
		}

		return directive;

		function multipleChoiceController($scope) {
			var vm = this;

			vm.choices = [];
      vm.parameters = null;
      vm.questionId = vm.element.data.id;

			initQuestion();

			function initQuestion() {
				angular.forEach(vm.element.data.objects, function (value) {
					switch (value.type) {
						case 'choice' :
							vm.choices.push(value.data);
							break;
						case 'parameter' :
							vm.parameters = value.data;
							break;
					}
        });

				if (vm.parameters.random == 1) {
                    vm.choices.sort(function() {
                        return Math.random() - 0.5;
                    });
                }

        $scope.$watch('vm.element.doesntAnswerInputChecked[vm.questionId]', function() {
          if(angular.isDefined(vm.element.doesntAnswerInputChecked[vm.questionId]) && vm.element.doesntAnswerInputChecked[vm.questionId]) {
            angular.forEach(vm.element.data.objects, function(value) {
              // on décoche toutes les cases
              if(vm.element.response && value.type == "choice") {
                vm.element.response[parseInt(value.data.id)] = false;
              }
            })
          }
        });
			}
		}
	}
})();


(function () {
	'use strict';

	angular
		.module('respondentClient')
		.directive('questionFreeText', questionFreeText);

	function questionFreeText() {
		var questionFreeText = {
			restrict: 'E',
			scope: {
				element: '='
			},
			templateUrl: 'app/views/directives/questionnaire/elements/questions/free-text.html',
			controller: freeTextController,
			controllerAs: 'vm',
			bindToController: true
		};

		return questionFreeText;

		function freeTextController($scope,$rootScope) {
			var vm = this;

			vm.parameters = null;

			__initQuestion();

			function __initQuestion() {
				angular.forEach(vm.element.data.objects, function (value) {
					if (value.type == 'parameter') {
						vm.parameters = value.data;
					}
				});

				$scope.$watch('$root.checkIfCondition[vm.element.data.id]', function () {
                    if($rootScope.checkIfCondition[vm.element.data.id] != null && !$rootScope.checkIfCondition[vm.element.data.id]){
                        vm.element.response='';
                    }
				});

                if (vm.element.response != null && Object.keys(vm.element.response).length > 0) {
                    vm.element.haveChoiceResponse = true;
                } else {
                    vm.element.response = "";
                    vm.element.haveChoiceResponse = false;
				}

			}
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('respondentClient')
        .directive('questionAssociative', questionAssociative)

    function questionAssociative($filter, $window) {
        return {
            restrict: 'E',
            scope: {
                element: '='
            },
            templateUrl: "app/views/directives/questionnaire/elements/questions/associative.html",
            controller: AssociativeController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        function link(scope) {
            // Calcul la hauteur du svg apres le chargement des choix (voir la hauteur des li)
            scope.$watch('scope.vm.choices', function () {
                if(angular.isDefined(scope)) {
                    scope.vm.resizeELements();
                }
            }, true);

            // Recalcule les coordonnées des liens lors du redimensionnement de la fenêtre
            angular.element($window).on('resize.doResize', function () {
                scope.vm.resizeELements();
                scope.$apply();
            });
        }

        function AssociativeController($scope) {
            var vm = this;

            __initQuestion();

            function __initQuestion() {
                vm.questionId = vm.element.data.id;
                vm.differenceBetweenLeftChoices = [];
                vm.differenceBetweenRightChoices = [];

                vm.leftChoices = $filter('filter')(vm.element.data.objects, function (obj) {return obj.type == 'choice' && obj.data.float == "left";}, true);
                vm.rightChoices = $filter('filter')(vm.element.data.objects, function (obj) {return obj.type == 'choice' && obj.data.float == "right";}, true);

                vm.choices = [];
                vm.parameters = null;

                // functions
                vm.drawLeft = drawLeft;
                vm.drawRight = drawRight;
                vm.removeLine = removeLine;
                vm.indexInChoicesArray = indexInChoicesArray;
                vm.calculDifferenceBetweenChoices = calculDifferenceBetweenChoices;
                vm.resizeELements = resizeELements;

                vm.svgLinePositions = [];
                vm.svgLines = [];
                vm.selectedLeftItem = null;
                vm.selectedrightItem = null;

                var choiceIds = new Array();

                angular.forEach(vm.element.data.objects, function (value) {
                    switch (value.type) {
                        case 'choice' :
                            if(choiceIds.indexOf(value.data.id) == -1) {
                                choiceIds.push(value.data.id);
                                vm.choices.push(value.data);
                            }
                            break;
                        case 'parameter' :
                            vm.parameters = value.data;
                            break;
                    }
              });

              if (vm.element.response != null) {
                vm.svgLines = vm.element.response;
              }

              $scope.$watch('vm.element.doesntAnswerInputChecked[vm.questionId]', function(value) {
                    if(angular.isDefined(vm.element.doesntAnswerInputChecked[vm.questionId]) && vm.element.doesntAnswerInputChecked[vm.questionId]) {
                        // on supprime tous les liens existants lorsque l'utilisateur ne souhaite pas répondre
                        vm.element.response = [];
                        vm.svgLines = [];
                        vm.selectedLeftItem = null;
                        vm.selectedrightItem = null;
                    }
                });
            }

            function getDifferenceBetweenChoices(choices) {
                var result = [];
                var elementChoiceHeight = [];
                angular.forEach(choices, function (value, index) {
                    var elementChoice = angular.element('#ele-' + value.data.id);

                    var height = parseInt(elementChoice.css('height'));
                    var marginTop = parseInt(elementChoice.css('margin-top'));
                    var borderTopWidth = parseInt(elementChoice.css('border-top-width'));

                    var step = (height/2) + marginTop + borderTopWidth + 4; // +4 différence entre la liste des choix et svg
                    var stepTmp = height + marginTop + borderTopWidth;

                    if (index == 0) {
                        result[index] = step;
                    } else {
                        angular.forEach(elementChoiceHeight, function (value1) {
                            step += (value1);
                        });
                        result[index] = step;
                    }

                    elementChoiceHeight[index] = stepTmp;
                });
                return result;
            }

            /**
             * Calcule la hauteur (en px) entre deux choix qui se suivent
             */
            function calculDifferenceBetweenChoices() {
                vm.differenceBetweenLeftChoices = getDifferenceBetweenChoices(vm.leftChoices);
                vm.differenceBetweenRightChoices = getDifferenceBetweenChoices(vm.rightChoices);
                vm.resizeELements();
            }

            /**
             * Recalcule la position des chacuns des arcs
             */
            function resizeELements() {
                var svgElement = angular.element('#svg');
                vm.svgElementWidth = parseInt(svgElement.css('width'));

                var leftList = angular.element('#leftList');
                var leftListHeight = parseInt(leftList.css('height'));
                var rightList = angular.element('#rightList');
                var rightListHeight = parseInt(rightList.css('height'));
                var height = Math.max(leftListHeight, rightListHeight);
                svgElement.height(height+'px');

                angular.forEach(vm.svgLines, function (line) {
                    // on recalcule la position des lignes
                    if(vm.differenceBetweenLeftChoices && vm.differenceBetweenRightChoices) {
                        var positionChoiceNumber = vm.indexInChoicesArray(vm.leftChoices, line.leftLink);
                        line.y = vm.differenceBetweenLeftChoices[positionChoiceNumber];

                        positionChoiceNumber = vm.indexInChoicesArray(vm.rightChoices, line.rightLink);
                        line.ly = vm.differenceBetweenRightChoices[positionChoiceNumber];

                        line.lx = vm.svgElementWidth;

                    }
                });
            }

            /**
             * clique sur un élément de gauche
             * @param e
             * @param id
             */
            function drawLeft(e, id) {
                vm.selectedLeftItem = id;
                vm.selectedrightItem = null;

                var positionChoiceNumber = indexInChoicesArray(vm.leftChoices, id);
                vm.fromY = vm.differenceBetweenLeftChoices[positionChoiceNumber];
            }

            /**
             * clique sur un élément de droite
             * @param e
             * @param id
             */
            function drawRight(e, id) {
                vm.selectedrightItem = id;
                vm.toX = vm.svgElementWidth;

                var positionChoiceNumber = indexInChoicesArray(vm.rightChoices, id);
                vm.toY = vm.differenceBetweenRightChoices[positionChoiceNumber];

                if (vm.selectedLeftItem != null) {
                    // si un élément de gauche a été sélectionné
                    if (vm.svgLinePositions[vm.svgLinePositions.length - 1] != null && Object.keys(vm.svgLinePositions[vm.svgLinePositions.length - 1]).length < 5) {
                        // la ligne à dessiner est horizontale
                        vm.svgLinePositions[vm.svgLinePositions.length - 1]["lx"] = vm.toX;
                        vm.svgLinePositions[vm.svgLinePositions.length - 1]["ly"] = vm.toY;
                        vm.svgLinePositions[vm.svgLinePositions.length - 1]["rightLink"] = id;
                    } else {
                        // la ligne à dessiner est en diagonal
                        var rightElement = {
                            "leftLink": vm.selectedLeftItem,
                            "x": 0,
                            "y": vm.fromY,
                            "lx": vm.toX,
                            "ly": vm.toY,
                            "rightLink": id
                        };
                        var foundItem = $filter('filter')(vm.svgLinePositions, rightElement, true)[0];
                        if (!foundItem) {
                            vm.svgLinePositions.push(rightElement);
                        }
                    }
                    if (vm.element.response != null) {
                        if (vm.svgLinePositions.length == 1 && vm.svgLinePositions != vm.element.response) {
                            vm.svgLinePositions = vm.svgLinePositions.concat(vm.element.response);
                        } else {
                            vm.svgLinePositions = vm.element.response;
                        }
                    }
                    vm.svgLines = vm.svgLinePositions;
                    vm.element.response = vm.svgLines;
                }
            }

            function removeLine(index) {
                vm.element.response.splice(index, 1);
                vm.svgLines.slice(index, 1);
                vm.selectedrightItem = null;
                vm.selectedLeftItem = null;
            }

            /**
             * retourne l'indice du choix correspondant à l'id dans le tableau fourni
             * @param {*} array
             * @param {*} id
             */
            function indexInChoicesArray(array, id) {
                return array.map(function(choice) {
                    return choice.data.id
                }).indexOf(id);
            }
        }
    }
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('textElement', function () {
      return {
        restrict: 'E',
        scope: {
          element: '='
        },
        replace: true,
        transclude:true,
        templateUrl: "app/views/directives/questionnaire/elements/text-element.html"
      }
    });
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('sectionElement', function () {
      return {
        restrict: 'E',
        scope: {
          element: '='
        },
        replace: true,
        transclude:true,
        templateUrl: "app/views/directives/questionnaire/elements/section-element.html"
      }
    });
})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.directive('questionElement', questionElement);

	function questionElement($compile,$rootScope, $filter, alertsFactory, QuestionFactory) {
		var directive = {
			bindToController: true,
			controller: QuestionElementController,
			controllerAs: 'vm',
			link: link,
			restrict: 'E',
			scope: {
				element: '='
			},
			templateUrl: 'app/views/directives/questionnaire/elements/questions/question.html'
		};

		return directive;

		function link(scope, elements) {


			/*si il n'existe pas on le construit*/
			if(!$rootScope.checkIfCondition){$rootScope.checkIfCondition = []}
			if(!$rootScope.tabRico){$rootScope.tabRico = []}

			angular.forEach(scope.vm.element.data.objects, function(value){
				$rootScope.arraySources=[];
				$rootScope.arrayTarget=[];
				if(value.type == "condition" && $rootScope.organizationPrefix == 'socotec'){
					var target_1=value.data.sources[0].data.id;
					var target_2=value.data.sources[1].data.id;
					$rootScope.arrayTarget.push(target_1);
					$rootScope.arrayTarget.push(target_2);
					var monIndex=0;
					angular.forEach(value.data.targets, function(value){

						if (!$rootScope.checkIfCondition.hasOwnProperty(scope.vm.element.data.id)){
							$rootScope.checkIfCondition[value.data.id]=[];
						}
						$rootScope.checkIfCondition[value.data.id]=false;
						$rootScope.arraySources[$rootScope.arrayTarget[monIndex + '']]=value.data.id
						monIndex++;
					});
					for (var key in $rootScope.arraySources) {
						if (!$rootScope.tabRico.hasOwnProperty(scope.vm.element.data.id)){
							$rootScope.tabRico[scope.vm.element.data.id]=[];
						}
						$rootScope.tabRico[scope.vm.element.data.id][key]=$rootScope.arraySources[key];
					}
				}
            });
            /* on passe un constructeur */
            if ($rootScope.checkIfCondition) {
                scope.vm.conditionDisplay = QuestionFactory.conditionDisplay(scope.vm.element,$rootScope.checkIfCondition,$rootScope.montableau)
			}

			scope.vm.element.haveChoiceResponse = false;
			scope.vm.element.preValidate = QuestionFactory.preValidate;
			var questionObject = $filter('filter')(scope.vm.element.data.objects, {type: 'parameter'});
			scope.vm.commentable = questionObject[0].data.commentable;
			scope.vm.mandatory = questionObject[0].data.nonActivable;


			scope.vm.doesntAnswerInputLabel = questionObject[0].data.nonActivableLabel;
            if(angular.isObject(QuestionFactory.getQuestionProperties(scope.vm.element).options)){
                scope.vm.element.showCommentByScale = QuestionFactory.getQuestionProperties(scope.vm.element).options.showCommentByScale;
                scope.vm.element.showDoesNotAnswerByScale = QuestionFactory.getQuestionProperties(scope.vm.element).options.showDoesNotAnswerByScale;
            }

			var directiveName = QuestionFactory.getQuestionProperties(scope.vm.element).directiveName;

			var template = '<question-' + directiveName + ' element="vm.element"></question-' + directiveName + '>';
			elements.find('.questionType').append(template);
			$compile(elements.contents())(scope);

			scope.vm.elementId = angular.isDefined(scope.vm.id) ? scope.vm.id : scope.vm.element.data.id;

			// Lance le processus de validation lors d'une réponse
			scope.$watch('vm.element.response', function (items) {
				if (items !== null) {
					QuestionFactory.doValidation(scope.vm.element, false);
				}
			}, true);

            scope.$watch('vm.element.comment', function (items) {
                if (items !== null) {
                    QuestionFactory.doValidation(scope.vm.element, false);
                }
            }, true);
		}

		function QuestionElementController() {
			var vm = this;
		}
	}
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('objectiveslistElement', objectiveslistElement);

    function objectiveslistElement() {
      return {
        restrict: 'E',
        scope: {
          element: '='
        },
        templateUrl: "app/views/directives/questionnaire/elements/objectivesList-element.html"
      }
    }
})();

/**
 * Created by ben on 02/11/17.
 */
(function () {
    'use strict';
    angular.module('respondentClient')
        .directive('doesNotAnswer', function (alertsFactory) {
            return {
                restrict: 'E',
                scope: {
                    element: '=',
                    disabled: '=',
                    label: '='
                },
                templateUrl: "app/views/directives/questionnaire/elements/does-not-answer.html",
                replace: true,
                transclude: true,
                controller: doesNotAnswerController,
                controllerAs: 'vm',
                bindToController: true
            };

            function doesNotAnswerController($scope) {
                var vm = this;
                if ( Object.keys(vm.element.doesntAnswerInputChecked).length === 0 ) {
                    vm.element.doesntAnswerInputChecked = {};
                }
                vm.vmDisabled = vm.disabled.toString();
                vm.isBeforeAfter = (angular.isDefined(vm.element.data.objects[0].data.beforeAfter) && vm.element.data.objects[0].data.beforeAfter == 1) ? true : false;
                vm.element.doesntAnswerInputChecked[vm.vmDisabled] = (angular.isDefined(vm.element.doesntAnswerInputChecked[vm.vmDisabled])) ? vm.element.doesntAnswerInputChecked[vm.vmDisabled] : false;

                // Cacher les erreurs lorsqu'on appuie sur le bouton 'Ne pas répondre'
                $scope.$watch('vm.element.doesntAnswerInputChecked[vm.disabled]', function(value) {

                    if ( vm.isBeforeAfter && angular.isDefined(value) ) {
                        vm.element.doesntAnswerInputChecked[vm.vmDisabled + '-before'] = value;
                        vm.element.doesntAnswerInputChecked[vm.vmDisabled + '-after'] = value;
                    }
                    if (value === true) {
                        vm.element = alertsFactory.remove(vm.element);
                    }
                });

            }

        });
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('commentByScale', function () {
      return {
        restrict: 'E',
        scope: {
          element: '=',
          id:'='
        },
        templateUrl: "app/views/directives/questionnaire/elements/questions/comment-by-scale.html",
        replace: true,
        transclude: true,
        controller: commentController,
        controllerAs: 'vm',
        bindToController: true
      };

      function commentController($scope) {
        var vm = this;
        vm.showTextArea = [];
        vm.showTextArea[vm.id] = (vm.element.comment != null && vm.element.comment[vm.id] != null ) ? true : false;
        $scope.$watch('vm.showTextArea[vm.id]', function (newValue) {
          if (!newValue && vm.element.comment != null && vm.element.comment[vm.id]!=null ) {
            vm.element.comment[vm.id] = null;
          }
        });
      }

    });
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('comment', function () {
      return {
        restrict: 'E',
        scope: {
          element: '=',
          id: '='
        },
        templateUrl: "app/views/directives/questionnaire/elements/questions/comment.html",
        replace: true,
        transclude: true,
        controller: commentController,
        controllerAs: 'vm',
        bindToController: true
      };

      function commentController($scope) {
        var vm = this;
        vm.elementId = angular.isDefined(vm.id) ? vm.id : vm.element.data.id;
        vm.showTextArea = [];
        vm.showTextArea[vm.elementId] = (vm.element.comment != null && vm.element.comment[vm.elementId] != null) ? true : false;
        $scope.$watch('vm.showTextArea[vm.elementId]', function (newValue) {
          if (!newValue && vm.element.comment != null && vm.element.comment[vm.elementId] != null) {
            vm.element.comment[vm.elementId] = null;
          }
        });
      }

    });
})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.controller('UniqueChoiceController', UniqueChoiceController);

	function UniqueChoiceController( $scope,$rootScope) {
		var vm = this;
		__initialize();

		function __initialize() {
			vm.choices = [];
			vm.parameters = null;

			$scope.$watch('vm.element.response', function (value) {
				if ($rootScope.tabRico.hasOwnProperty(vm.element.data.id) && $rootScope.tabRico[vm.element.data.id].hasOwnProperty(value)) {
					angular.forEach($rootScope.tabRico[vm.element.data.id], function(values){
						for (var key in $rootScope.tabRico[vm.element.data.id]) {
							$rootScope.checkIfCondition[values]=false;
						}
					});
					$rootScope.checkIfCondition[$rootScope.tabRico[vm.element.data.id][value]]=true;
				} else {
					angular.forEach($rootScope.tabRico[vm.element.data.id], function(values){
						for (var key in $rootScope.tabRico[vm.element.data.id]) {
							$rootScope.checkIfCondition[values]=false;
						}
					});
				}
			});

			angular.forEach(vm.element.data.objects, function (value) {

				switch (value.type) {
					case 'choice' :
						vm.choices.push(value.data);
						break;
					case 'parameter' :
						vm.parameters = value.data;
						break;
				}
			});

            $scope.$watch('vm.element.doesntAnswerInputChecked[vm.element.data.id]', function() {
                if (angular.isDefined(vm.element.doesntAnswerInputChecked[vm.element.data.id]) && vm.element.doesntAnswerInputChecked[vm.element.data.id]) {
                    vm.element.response = '';
                }
            });
		}
	}
})();

(function () {
	'use strict'

	angular
		.module('respondentClient')
		.controller('SurveyDirectiveController', SurveyDirectiveController);

	function SurveyDirectiveController($timeout, $scope, $rootScope, $filter, localStorageFactory, $stateParams, QuestionFactory, scrollFactory, surveysService, formatJsonSurveyFactory, responsesService, ipCookie, alertsFactory) {
		var vm = this;

		__initialize();

		function __initialize() {
			vm.terminate = terminate;
			vm.validate = validate;
			vm.next = next;
			vm.before = before;
			vm.removeAllToasters = removeAllToasters;
			vm.submitted = false;
			vm.conditionalQuestionsMessage = false;
			vm.isOperaMini = (navigator.userAgent.indexOf('Opera Mini') > -1);
			vm.currentSurveysIndex = 0;
			// si le user à recharge la page et il a dèjà repondu au questionniare global alors le questionnaire
			// courant devient le questionnaire suivant

			/**
			 * ce code permet si on rafraichi la page et on est dans un questionaire conditionné
			 * on doit pas le charge une autre fois
			 */
			angular.forEach(vm.surveys, function (value, index) {
				if (value.answered == 1) {
					vm.currentSurveysIndex = index + 1;
				}
			});

            $rootScope.currentSurveysIndex = vm.currentSurveysIndex;
            $rootScope.organizationPrefix = $stateParams.organization;

			vm.countSurveys = vm.surveys.length;
			vm.currentPageIndex = 0;
			vm.countPages = vm.surveys[vm.currentSurveysIndex].pages.length;
			vm.currentPage = vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex];
			vm.surveyHash = $stateParams.surveyHash;

			if (!vm.isOperaMini) {
                vm.surveysCache = angular.fromJson(localStorageFactory.get(vm.surveyHash));
                vm.parameters = vm.surveysCache.parameters;
                vm.conditionalQuestions = vm.surveysCache.conditionalQuestions;
			} else {
				vm.surveysCache = {'surveys': vm.surveys, 'summary': vm.summary, 'parameters': vm.parameters}
			}

			vm.surveysCache['conditions'] = [];
			vm.responses = [];
			vm.finalMessageValidation = {};
			vm.previewsBtnTxt = 'PREVIOUS_STEP';
			vm.nextBtnTxt = 'NEXT_STEP';
			vm.lastPageInLastSurveys = false;
            vm.waitingForConditionalSurveys = false;
		}

		/**
		 * changer le texte des boutons suivant et précedant
		 */
		$scope.$watch(function () {
			return vm.currentPageIndex;
		}, function (newValue) {
			_getTextBtnAfterChangeSurveys(newValue);
		});

		/**
		 * adatpter les texte des boutons apres chaque changement des questionnaires
		 * @param newValue
		 * @private
		 */
		function _getTextBtnAfterChangeSurveys(newValue) {
			vm.countPages = vm.surveys[vm.currentSurveysIndex].pages.length;
			vm.lastPageInLastSurveys = false;

			if (newValue == vm.countPages - 1) {
				vm.nextBtnTxt = 'NEXT';
			} else {
				vm.nextBtnTxt = 'NEXT_STEP';
			}

			if (newValue == 0 && vm.surveys[vm.currentSurveysIndex - 1] != undefined) {
				vm.previewsBtnTxt = 'PREVIOUS'
			} else {
				vm.previewsBtnTxt = 'PREVIOUS_STEP';
			}

			if (vm.surveys[vm.currentSurveysIndex + 1] == undefined && newValue == vm.countPages - 1) {
				vm.lastPageInLastSurveys = true;
			}
		}

		/**
		 * fonction pour le bouton suivant
		 */
		function next() {
			var validate = vm.validate();

			if (validate) {

				vm.surveysCache.surveys[vm.currentSurveysIndex] = vm.surveys[vm.currentSurveysIndex];
				if (!vm.isOperaMini) {
					localStorageFactory.save(vm.surveyHash, vm.surveysCache);
				}
				/// si je suis dans la dernierer page du questionniare courant je incremente le numero de questionnaire
				if (vm.currentPageIndex == vm.countPages - 1) {
					vm.currentSurveysIndex = vm.currentSurveysIndex + 1;
					vm.currentPageIndex = 0;
					_getTextBtnAfterChangeSurveys(vm.currentPageIndex);
					vm.currentPage = vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex];
				} else {
					vm.currentPageIndex = vm.currentPageIndex + 1;
					vm.currentPage = vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex];
				}
                $rootScope.currentSurveysIndex = vm.currentSurveysIndex;
                window.scrollTo(0, 0);
            }
		}

		/**
		 * fonction du bouton precedent
		 */
		function before() {
			// Evite que les toasters restent affichés programmatiquement (showAlert = true)
			// alors qu'ils ne sont pas visible sur l'interface
			vm.removeAllToasters();

			// Si on est à la page un et on a encore un questionnaire
			if (vm.currentPageIndex == 0 && vm.surveys[vm.currentSurveysIndex - 1] != undefined) {
				vm.currentSurveysIndex = vm.currentSurveysIndex - 1;
				vm.currentPageIndex = vm.surveys[vm.currentSurveysIndex].pages.length - 1;
				vm.currentPage = vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex];
				_getTextBtnAfterChangeSurveys(vm.currentPageIndex);
			} else {
				vm.currentPageIndex = vm.currentPageIndex - 1;
				vm.currentPage = vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex];
			}
            $rootScope.currentSurveysIndex = vm.currentSurveysIndex;
            window.scrollTo(0, 0);
        }

		function removeAllToasters() {
			angular.forEach(vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex], function (value, key) {
				if (value.type === 'question') {
					vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex][key] = alertsFactory.remove(value);
				}
			});
		}

		/**
		 * validation des questions de la page courante
		 * @returns {boolean}
		 */
		function validate() {
			var haveNotError;
			var questionValidate = undefined;

			angular.forEach(vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex], function (value, key) {

				if (value.type == 'question') {

					questionValidate = QuestionFactory.doValidation(value);

					// si la question est valide on prepare la reponse
					if(questionValidate.validator.isValid){

						vm.parameters.questionnaireId = vm.surveys[vm.currentSurveysIndex].id;
						questionValidate = QuestionFactory.doTransformation(questionValidate, vm.parameters);
					}

					vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex][key] = questionValidate;


				}
			});



			haveNotError = _errorNotExistInCurrentSurveyPage(vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex]);

			if (!haveNotError) {
				// faire défiler à la première erreur
				scrollFactory.scrollToErrorElement(vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex]);
			}

			return haveNotError;
		}

		/**
		 * fonction de finalisation et envoi les reponses N-Api
		 */
		function terminate() {

			// setter dans le chache les ids des questionnaire conditionné
			_fillConditionSurveysIdsInLocalStorage(vm.surveys);
			var validate = vm.validate();

			// Permet de cacher le bouton validé pour empêcher les doubles click
			vm.flagIsValidate = validate && vm.surveysCache.conditions == null;

			if (validate) {
				vm.currentPage = vm.surveys[vm.currentSurveysIndex].pages[vm.currentPageIndex];
				vm.surveysCache.surveys[vm.currentSurveysIndex] = vm.surveys[vm.currentSurveysIndex];

				if (!vm.isOperaMini) {
					localStorageFactory.save(vm.surveyHash, vm.surveysCache);
				}

				/**
				 * ce code permet si on rafraichi la page et on est dans un questionaire conditionné
				 * on doit pas le charge une autre fois
				 */
				angular.forEach(vm.surveysCache.surveys, function (value) {
					if (value.answered == 1) {
						vm.surveysCache.conditions = null;
					}
                });

				/// si j'ai des questionnaires conditionné
				if (vm.surveysCache.conditions != null && vm.surveysCache.conditions.length > 0) {
					vm.waitingForConditionalSurveys = true;

					/// on récupere les questionnaire conditionné
					surveysService.get(vm.surveysCache.conditions).then(function (response) {
						vm.waitingForConditionalSurveys = false;

						if (response.status == 200) {
							var surveysFormatted = formatJsonSurveyFactory.format({list: response.data}, true);

							if (!vm.isOperaMini) {
								// on recupere les donnes form localstorage
								var surveysFromLocalStorage = angular.fromJson(localStorageFactory.get(vm.surveyHash));
								//surveysFromLocalStorage.conditions =null;
								vm.surveysCache.conditions = null;
								//bloquer le questionnaire globale
								surveysFromLocalStorage.surveys[vm.currentSurveysIndex].answered = 1;
								// on update les surveys tout en ajoutant les surveys conditionné
								angular.forEach(surveysFormatted.surveys, function (value) {
									surveysFromLocalStorage.surveys.push(value);
								});
								// on enregistre l'ensemble des données dans le localstorage
								localStorageFactory.save(vm.surveyHash, {
									surveys: surveysFromLocalStorage.surveys,
									summary: surveysFromLocalStorage.summary,
									parameters: surveysFromLocalStorage.parameters,
									conditions: vm.surveysCache.conditions,
									conditionalQuestions: vm.surveysCache.conditionalQuestions
								});
								vm.surveys = surveysFromLocalStorage.surveys;
								vm.surveysCache = angular.fromJson(localStorageFactory.get(vm.surveyHash));
							} else {
								vm.surveys = vm.surveys.concat(surveysFormatted.surveys);
								vm.surveysCache.surveys = vm.surveysCache.surveys.concat(surveysFormatted.surveys);
								vm.surveysCache.conditions = null;
							}

							vm.countSurveys = vm.surveys.length;
							vm.next();
							vm.waitingForConditionalSurveys = false;
						}
					});
				} else {

					_sendResponseToApi();

				}
			}
		}

		/**
		 * chercher les erruer dans l'objet element
		 * @param elements
		 * @returns {boolean}
		 * @private
		 */
		function _errorNotExistInCurrentSurveyPage(elements) {
			var errorCounter = 0;


			angular.forEach(elements, function (value) {
				if (value.type == 'question' && value.validator.isValid === false) {
					errorCounter++;
				}
			});

			return (errorCounter > 0) ? false : true;
		}

		/**
		 * elle recuper les ids des questionniare conditionné afun de l'engistrer dans le localstorage
		 * @param surveys
		 * @private
		 */
		function _fillConditionSurveysIdsInLocalStorage(surveys) {
			vm.surveysCache['conditionalQuestions'] = [];
			angular.forEach(surveys, function (survey) {
				angular.forEach(survey.pages, function (page) {
					angular.forEach(page, function (ele) {
						if (ele.type == 'question' && ele.conditions != null) {
                            // si le survey n'existe pas dans le surveyCache on l'ajoute dans la liste des questionnaire à recuperer
                            // si l'id de la condition est égal à 0, cela signifie qu'il n'y a pas de questionnaire de niveau 2 ; il ne faut donc pas l'ajouter à la liste des questionnaire
							if (vm.surveysCache['conditions'] != null && vm.surveysCache['conditions'].indexOf(ele.conditions.data.id) == -1 && ele.conditions.data.id != "0") {
								vm.surveysCache['conditionalQuestions'].push(_getConditionalQuestionObject(ele));
								vm.surveysCache['conditions'].push(ele.conditions.data.id);
							}
						}
					});
				});
			});
		}

		/**
		 * elle remplir les reponses et les envoyer au N-Api
		 * @private
		 */
		function _sendResponseToApi() {
			var surveys = (vm.countPages == 1) ? vm.surveys : vm.surveysCache.surveys;

			var questionsBySurveys = _getAllQuestionsBySurveys(surveys);

			angular.forEach(questionsBySurveys,function (questionsInSurveys,key) {
				vm.responses[key] = [];
				angular.forEach(questionsInSurveys, function(question) {
					/*checkScale si transformedResponseFor api est undefined on ne push rien dans l'objet */
                    if (angular.isDefined(question.transformedResponseForApi) && question.transformedResponseForApi.hasOwnProperty('type')) {
                        vm.responses[key].push(question.transformedResponseForApi);

                    }
				});
			});

			responsesService.save(vm.responses, questionsBySurveys).then(function successCallback() {
				localStorageFactory.remove(vm.surveyHash);
				ipCookie.remove(vm.surveyHash);
				vm.finalMessageValidation = {text : 'SUCCESS_REGISTER', success: true};
				alertsFactory.show({message:vm.finalMessageValidation.text},'success');
				},function errorCallback() {
				//on reste sur l'index courant pour garder le bouton terminate
				vm.finalMessageValidation = {text : 'ERROR_REGISTER', success: false};
				alertsFactory.show({message:vm.finalMessageValidation.text},'warning');
			});
		}

		/**
		 * elle construit un objet conditionanl question pour l'enregister dans le cache
		 * @param ele
		 * @returns {{loaded: number, conditionalQuestion: {id: *, title: *, response: string}}}
		 * @private
		 */
		function _getConditionalQuestionObject(ele) {
			var conditionalQuestion = {
				'surveysId': ele.conditions.data.id,
				'question': {'id': ele.data.id, 'title': ele.data.title, 'response': ''}
			};

			angular.forEach(ele.data.objects, function (choice) {
				if (choice.data.id == ele.response) {
					conditionalQuestion.question.response = choice.data.title;
				}
			});

			return conditionalQuestion;
		}


		function _getAllQuestionsBySurveys(surveys) {
			var questions = [];
			angular.forEach(surveys, function (survey, key) {
				questions[key] = [];
				angular.forEach(survey.pages, function (page) {
					angular.forEach(page, function (question) {
						// permet de ne pas récupérer les éléments "text" (qui ne sont pas des questions)
						if(question.type == "question"){
							questions[key].push(question);
						}
					});
				});
			});

			return questions;
		}

		/**
		 * un watch sur id du questionnaire si il change on regarde si il existe dans lobject condionalQuestion
		 * afin d'afficher le message 'CONDITIONAL_QUESTION_MSG'
		 */
		$scope.$watch(function () {
			return vm.surveys[vm.currentSurveysIndex].id
		}, function (newSurveyId) {
			if (vm.surveysCache.conditionalQuestions != undefined && vm.surveysCache.conditionalQuestions.length > 0) {
				angular.forEach(vm.surveysCache.conditionalQuestions, function (ele) {
					if (ele.surveysId == newSurveyId) {
						vm.conditionalQuestionsMessage = {
							surveys: vm.surveys[vm.currentSurveysIndex].name,
							title: ele.question.title,
							response: ele.question.response
						};
					}
				});
			}
        });

        $scope.$watch('vm.surveys', function() {
            // dans le cas où le questionnaire est mis à jour, il faut relancer le constructeur afin de charger le nouveau questionnaire
            __initialize();
            _getTextBtnAfterChangeSurveys(0);
        });
	}
})();

(function() {
    'use strict'

    angular
        .module('respondentClient')
        .service('UsersService', UsersService);

    function UsersService($http, configuration) {
        var url = configuration.protocol_type + '//' + configuration.server_name;
        this.getFirstAndLastNames = getFirstAndLastNames;

        /**
         * @description Récupère une liste de prénom et une liste de nom des participants d'une évaluation
         * @param {integer} measureId
         * @param {string} surveyHash
         */
        function getFirstAndLastNames(measureId, surveyHash) {
            var uri = url + '/evaluation/users';
            return $http({
                    method: 'GET',
                    url: uri,
                    headers: { 'Content-Type': 'application/json', 'Authorization': surveyHash }
                })
                .then(function(result) {
                    return result.data;
                });
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('respondentClient')
		.service('surveysService', surveysService);

	function surveysService($http, configuration) {
		var url = configuration.protocol_type + '//' + configuration.server_name;
    this.getList = getList;
    this.getListDate = getListDate;
		this.get = get;

    // multi trainers
		function getList() {
			var uri = url + '/surveys';

			return $http({
        method: 'GET',
        url: uri,
        headers: {'Content-Type': 'application/json'}
			});
    }

    function getListDate() {
      var uri = url + '/surveysDate';

			return $http({
				method: 'GET',
        url: uri,
				headers: {'Content-Type': 'application/json'}
			});
    }

		function get(surveyIds) {
      var uri = url + '/surveys/' + surveyIds.toString();

			return $http({
				method: 'GET',
				url: uri,
				headers: {'Content-Type': 'application/json'}
			});
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('respondentClient')
        .service('registerformService', registerformService);

    function registerformService($http, configuration) {
        var url = configuration.protocol_type + '//' + configuration.server_name;
        this.post = post;
        this.get = get;

        function post(data) {
            // ici appel de service à r-api pour inscription
            var uri = url + '/evaluation/users';
            return $http({
                method: 'POST',
                url: uri,
                headers: { 'Content-Type': 'application/json' },
                data: { data: data }
            });
        }

        function get(flname) {
            var uri = url + '/evaluation/users/' + flname + '/fnamelname';
            return $http({
                method: 'GET',
                url: uri,
                headers: { 'Content-Type': 'application/json' },
                data: ''
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('respondentClient')
        .service('checkservicesService', checkservicesService);

    function checkservicesService($http, configuration) {
        var url = configuration.protocol_type + '//' + configuration.server_name;
        this.get = get;

        function get() {
            var uri = url + '/checkservices';
            return $http({
                method: 'GET',
                url: uri,
                headers: { 'Content-Type': 'application/json' },
                data: ''
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .filter('countSelectedChoices', countSelectedChoices);

  function countSelectedChoices() {
    return function (objects) {
      var count = 0;
      if(objects!= undefined){
        angular.forEach(objects,function(value){
        if(value == true){
          count ++;
        }
        });
        return count;
      }
      return count;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .filter('countAssociation', countAssociation);

  function countAssociation() {
    return function (objects) {
      var count = 0;
      if (objects != undefined) {
        angular.forEach(objects, function (value) {
          if(Object.keys(value).length >= 6){
            count++;
          }
        });
        return count;
      }
      return count;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .factory('surveysFactory', surveysFactory);

  function surveysFactory() {

    var surveysFactory = {
      localStorageIsUpToDate: localStorageIsUpToDate
    };
    return surveysFactory;

    /**
     * retourne true si le questionnaire du local storage est à jour
     * @param {*} arrayDates dates de dernières mises à jours
     * @param {*} arraySurveyLocalStorage questionnaire contenant les dates de mises à jour de chaque questionnaire
     */
    function localStorageIsUpToDate(arrayDates, arraySurveyLocalStorage) {

      var isUptoDate = true;
      if(arrayDates.length != arraySurveyLocalStorage.length) {
        // Il y a au moins un questionnaire manquant ou en trop
        isUptoDate = false;
      } else {
        var i = 0;
        while(i < arrayDates.length && isUptoDate == true) {
          if(arrayDates[i].templateId != arraySurveyLocalStorage[i].id) {
            // Les id des questionnaires ne correspondent pas
            isUptoDate = false;
          } else {
            var lastUpdatedDate = new Date(arrayDates[i].lastUpdatedDate);
            var lastUpdatedDateLocalStorage = new Date(arraySurveyLocalStorage[i].lastUpdatedDate);

            if(lastUpdatedDateLocalStorage < lastUpdatedDate) {
                isUptoDate = false;
            }
          }
          i++;
        }
      }
      return isUptoDate;
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.factory('rulesValidationsFactory', rulesValidationsFactory);

	function rulesValidationsFactory($filter) {
        var regex = new RegExp('\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]');

		var factory = {
			maxCheck: {
				validateAssociation: maxCheckValidateAssociation,
				validateMultiple: maxCheckValidateMultiple
			},
			minCheck: {
				validateMultiple: minCheckValidateMultiple
			},
			notBlank: {
				validateString: notBlankValidateString
			},
			required: {
				validateMultiple: requiredValidateMultiple,
				validateString: requiredValidateString
			},
            character: {
                validateNoUnicode: characterValidateNoUnicode,
                validateNoUnicodeComment: characterValidateNoUnicodeComment
            }
		};

		return factory;

		function maxCheckValidateAssociation(question) {
			var maxResponses = $filter('filter')(question.data.objects, {type:'parameter'})[0].data.maxResponses;
			return {
				'isValid': question.response.length <= maxResponses,
				'message': {
					value: "MSG_MAX_CHECK",
					priority: 3,
					params: {
						maxResponses: maxResponses
					}
				}
			};
		}

		function maxCheckValidateMultiple(question) {
			var maxResponses = $filter('filter')(question.data.objects,{type:'parameter'})[0].data.maxResponses;
			var selectedItems = 0;

			if (angular.isDefined(question.response)) {
				angular.forEach(question.response, function(value) {
					if (value === true) {
						selectedItems ++;
					}
				});
			}

			return {
				'isValid': selectedItems <= maxResponses,
				'message': {
					value: "MSG_MAX_CHECK",
					priority: 3,
					params: {
						maxResponses: maxResponses
					}
				}
			};
		}

		function minCheckValidateMultiple(question) {
			var minResponses = $filter('filter')(question.data.objects,{type:'parameter'})[0].data.minResponses;
			var selectedItems = 0;

			if (angular.isDefined(question.response)) {
				angular.forEach(question.response, function(value) {
					if (value === true) {
						selectedItems ++;
					}
				});
			}

			return {
				'isValid': selectedItems >= minResponses,
				'message': {
					value: "MSG_MIN_CHECK",
					priority: 2,
					params: {
						minResponses: minResponses
					}
				}
			};
		}

		function notBlankValidateString(value) {
			return {
				'isValid': /\S/.test(value),
                'message': {
					value:"MSG_NOT_BLANK",
					priority: 1
				}
			};
		}

        function characterValidateNoUnicode(value) {
            return {
                'isValid': !regex.test(value.response),
                'message': {
                    value:"MSG_CHARACTER_NO_UNICODE",
                    priority: 1
                }
            };
        }

        function characterValidateNoUnicodeComment(value) {
            var isValid = true;
            angular.forEach(value.comment, function(valueTmp) {
                if (isValid) {
                    if (regex.test(valueTmp)) {
                        isValid = false;
                    }
                }
            });

            return {
                'isValid': isValid,
                'message': {
                    value:"MSG_CHARACTER_NO_UNICODE",
                    priority: 1
                }
            };
        }

		function requiredValidateMultiple(question) {
			var isValid = true;

			if (question.response === null || question.response === "") {
				isValid = false;
			} else {
				isValid = question.response.length > 0;
			}

			return {
				'isValid': isValid,
				'message': {
					value: "MSG_VALUE_IS_REQUIRED",
					priority: 1
				}
			};
		}

		function requiredValidateString(question) {
			if (angular.isUndefined(question)) {
				return {
					'isValid': false,
					'message': {
						value: "MSG_VALUE_IS_REQUIRED",
						priority: 1
					}
				};
			}

			if (question.response === null || question.response === "") {
				return {
					'isValid': false,
					'message': {
						value: "MSG_VALUE_IS_REQUIRED",
						priority: 1
					}
				};
			}

			return {
				'isValid': /\S/.test(question.response),
				'message': {
					value: "MSG_VALUE_IS_REQUIRED",
					priority: 1
				}
			};
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('respondentClient')
        .factory('registerformFactory', registerformFactory);

    function registerformFactory($filter, alertsFactory) {

        var registerformFactory = {
            validate: validate,
            _validateRegisteredOnly: _validateRegisteredOnly,
            _validateAll: _validateAll,
            _validateRegisteredRequired: _validateRegisteredRequired,
            _existsInOrganization: _existsInOrganization
        };
        return registerformFactory;

        function validate(inputs, type) {
            var result;
            switch (type) {
                case 'all':
                    result = registerformFactory._validateAll(inputs);
                    break;
                case 'registration_required':
                    result = registerformFactory._validateRegisteredRequired(inputs);
                    break;
                case 'register_only':
                    result = registerformFactory._validateRegisteredOnly(inputs);
                    break;
                default:
                    result = false;
                    break;
            }
            return result;
        }

        function _validateAll(inputs) {
            var result = true;

            for (var propertyName in inputs) {
                if (angular.isUndefined(inputs[propertyName].value) && propertyName === 'email') {
                    alertsFactory.show(inputs[propertyName], 'mandatoryAccess');
                    result = false;
                }
            }

            return result;
        }

        function _validateRegisteredRequired(inputs) {
            var result = true;

            for (var propertyName in inputs) {
                if (inputs[propertyName].value.length === 0) {
                    alertsFactory.show(inputs[propertyName], 'mandatoryAccess');
                    result = false;
                }
            }

            return result;
        }

        // Todo unit testing when the function bellow will be written
        /* istanbul ignore next */
        function _validateRegisteredOnly(inputs) {
            var result = true;
            for (var propertyName in inputs) {
                if (inputs[propertyName].value.length === 0) {
                    alertsFactory.show(inputs[propertyName], 'mandatoryAccess');
                    result = false;
                }
            }
            return result;
        }

        /**
         * return false if the message in parameter contains "does not exist for your organization"
         * @param {*} data of the api-response
         */
        function _existsInOrganization(data) {
            var exists = true;
            if(angular.isDefined(data.results) && angular.isDefined(data.results.message) ) {
                exists = data.results.message.indexOf("does not exist for your organization") === -1;
            }
            return exists;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('respondentClient')
        .factory('QuestionObjectFactory', QuestionObjectFactory);

    function QuestionObjectFactory() {
        var questionObjectFactory = {
            build: build
        };

        return questionObjectFactory;

        function build(question, answers) {
            var answer = null;
            var result = {
                'data': question.data,
                'type': question.type,
                'response': null,
                'comment': null,
                'conditions': null,
                'validator': {},
                'doesntAnswerInputChecked': {}
            };

            if (answers && answers.rawData) {
                answer = window._.find(answers.rawData, function(r) {
                    return r.data.id === question.data.id;
                });
            }

            if (answer) {
                result.response = answer.response;
                result.comment = answer.comment;
                result.doesntAnswerInputChecked = answer.doesntAnswerInputChecked;
            }

            return result;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('respondentClient')
        .factory('QuestionFactory', QuestionFactory);

    function QuestionFactory(rulesValidationsFactory, $filter, formatResponsesFactory, QuestionConstants, alertsFactory) {
        var factory = {
            _getPropertiesArray: _getPropertiesArray,
            _getQuestionConditions: _getQuestionConditions,
            _getScaleObjectivesName: _getScaleObjectivesName,
            _isBeforeAfter: _isBeforeAfter,
            checkForError: checkForError,
            checkRules: checkRules,
            doTransformation: doTransformation,
            doValidation: doValidation,
            getQuestionProperties: getQuestionProperties,
            isAlertShown: isAlertShown,
            isAnswered: isAnswered,
            isDoesntAnswerChecked: isDoesntAnswerChecked,
            isMandatory: isMandatory,
            preValidate: preValidate,
            setHaveResponseForQuestion: setHaveResponseForQuestion,
            validate: validate,
            conditionDisplay:conditionDisplay
        };

        return factory;

        /**
         *  initialise le tableau contenant les configurations pour chaque type de question.
         */
        function _getPropertiesArray(isBeforeAfter) {
            var properties = [];

            properties[QuestionConstants.SCALE] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'scale',
                transformResponses: {
                    responsesType: 'questionScale',
                    responseObjectName: 'answerScales',
                    method: formatResponsesFactory.transformScale
                }
            };
            properties[QuestionConstants.BEFORE_AFTER_SCALE] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'scale-before-after',
                transformResponses: {
                    responsesType: 'questionBeforeAfterScale',
                    responseObjectName: 'answerBeforeAfterScales',
                    method: formatResponsesFactory.transformScale
                }
            };
            properties[QuestionConstants.UNIQUE_CHOICE] = {
                rules: [rulesValidationsFactory.required.validateString, rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'unique-choice',
                transformResponses: {
                    responsesType: 'questionUniqueChoice',
                    responseObjectName: 'answerUniqueChoices',
                    method: formatResponsesFactory.transformUniqueChoice
                }
            };
            properties[QuestionConstants.MULTIPLE_CHOICES] = {
                rules: [rulesValidationsFactory.minCheck.validateMultiple, rulesValidationsFactory.maxCheck.validateMultiple, rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'multiple-choice',
                transformResponses: {
                    responsesType: 'questionMultiChoice',
                    responseObjectName: 'answerMultiChoices',
                    method: formatResponsesFactory.transformMultipleChoice
                }
            };
            properties[QuestionConstants.QUIZ] = {
                rules: [rulesValidationsFactory.minCheck.validateMultiple, rulesValidationsFactory.maxCheck.validateMultiple],
                directiveName: 'multiple-choice',
                transformResponses: {
                    responsesType: 'questionQuiz',
                    responseObjectName: 'answerQuizs',
                    method: formatResponsesFactory.transformMultipleChoice
                }
            };
            properties[QuestionConstants.ORDERLY_RESPONSE] = {
                rules: [],
                directiveName: 'ordered-response',
                transformResponses: {
                    responsesType: 'questionOrderlyResponse',
                    responseObjectName: 'answerOrderlyResponses',
                    method: formatResponsesFactory.transformOrderlyResponse
                }
            };

            properties[QuestionConstants.PREFERENCE] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'preference',
                transformResponses: {
                    responsesType: 'questionPreference',
                    responseObjectName: 'answerPreferences',
                    method: formatResponsesFactory.transformPreference
                }
            };

            properties[QuestionConstants.FREE_TEXT] = {
                rules: [rulesValidationsFactory.character.validateNoUnicode],
                directiveName: 'free-text',
                transformResponses: {
                    responsesType: 'questionFreeText',
                    responseObjectName: 'answerFreeTexts',
                    method: formatResponsesFactory.transformFreeText
                }
            };
            properties[QuestionConstants.COMITMENT_ACHIEVING] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: factory._getScaleObjectivesName(isBeforeAfter),
                transformResponses: {
                    responsesType: 'questionCommitmentAchieving',
                    responseObjectName: 'answerCommitmentAchievings',
                    method: formatResponsesFactory.transformComitmentAchieving
                },
                options: {
                    showCommentByScale: true,
                    showDoesNotAnswerByScale: true
                }
            };
            properties[QuestionConstants.SCALE_OBJECTIVES] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: factory._getScaleObjectivesName(isBeforeAfter),
                transformResponses: {
                    responsesType: 'questionScaleObjective',
                    responseObjectName: 'answerScaleObjectives',
                    method: formatResponsesFactory.transformObjectiveScale
                },
                options: {
                    showCommentByScale: true,
                    showDoesNotAnswerByScale: true
                }
            };
            properties[QuestionConstants.SCALE_TRAINERS] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'scale-trainer',
                transformResponses: {
                    responsesType: 'questionScaleTrainer',
                    responseObjectName: 'answerScaleTrainers',
                    method: formatResponsesFactory.transformTrainerScale
                },
                options: {
                    showCommentByScale: true,
                    showDoesNotAnswerByScale: true
                }
            };
            properties[QuestionConstants.RECOMMENDATION_RATE] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'scale',
                transformResponses: {
                    responsesType: 'questionRecommendationRate',
                    responseObjectName: 'answerRecommendationRates',
                    method: formatResponsesFactory.transformRecommendationRateScale
                }
            };
            properties[QuestionConstants.WORD_MATCH] = {
                rules: [],
                directiveName: 'free-text',
                transformResponses: {
                    responsesType: 'questionWordMatch',
                    responseObjectName: 'answerWordMatchs',
                    method: formatResponsesFactory.transformFreeText
                }
            };
            properties[QuestionConstants.ASSOCIATIVE] = {
                rules: [rulesValidationsFactory.required.validateMultiple, rulesValidationsFactory.maxCheck.validateAssociation],
                directiveName: 'associative',
                transformResponses: {
                    responsesType: 'questionAssociation',
                    responseObjectName: 'answerAssociations',
                    method: formatResponsesFactory.transformAssociative
                }
            };
            properties[QuestionConstants.SCALE_SEQUENCES] = {
                rules: [rulesValidationsFactory.character.validateNoUnicodeComment],
                directiveName: 'scale-sequence',
                transformResponses: {
                    responsesType: 'questionScaleSequence',
                    responseObjectName: 'answerScaleSequences',
                    method: formatResponsesFactory.transformSequenceScale
                },
                options: {
                    showCommentByScale: true,
                    showDoesNotAnswerByScale: true
                }
            };
            properties[QuestionConstants.FOR_SUBJECT] = {
                rules: [rulesValidationsFactory.required.validateString],
                directiveName: 'unique-choice',
                transformResponses: {
                    responsesType: 'questionForSubject',
                    responseObjectName: 'answerForSubjects',
                    method: formatResponsesFactory.transformForSubject
                }
            };

            properties[QuestionConstants.CONDITIONNAL] = {
                rules: [rulesValidationsFactory.required.validateString],
                directiveName: 'conditionnel',
                transformResponses: {
                    responsesType: 'questionForSubject',
                    responseObjectName: 'answerForSubjects',
                    method: formatResponsesFactory.transformForSubject
                }
            };

            return properties;
        }

        /**
         *  _getScaleObjectivesName retourne le nom d'une directive 'scale-objectives' selon qu'elle soit de type 'avant-après' ou non.
         */
        function _getScaleObjectivesName(isBeforeAfter) {
            var directiveName = 'scale-objectives';

            if (isBeforeAfter) {
                directiveName = 'scale-objectives-before-after';
            }

            return directiveName;
        }

        /**
         *  checkRules vérifie les règles et retourne la première erreur rencontrée.
         */
        function checkRules(question, rules) {
            // pas obligé de répondre pour les questions de type 8 (freetext) et checkScaleisNull



            if (!factory.isAnswered(question) && question.data.type != QuestionConstants.FREE_TEXT && !question.data.checkScaleisNull) {
                return {
                    'value': 'MSG_VALUE_IS_REQUIRED',
                    'priority': 1
                };
            }

            var error = undefined;

            if (angular.isUndefined(rules) || rules.length < 1) {
                return error;
            }

            var next = true;
            var result = undefined;
            var i = 0;

            // S'arrête à la première erreur
            while (next && i < rules.length) {
                result = rules[i](question);

                if (angular.isDefined(result) && result.isValid !== true) {
                    error = result.message;
                    next = false;
                }

                i++;
            }

            return error;
        }

        /**
         *    getQuestionConditions retourne les conditions d'une question.
         */
        function _getQuestionConditions(question) {
            var conditions = $filter('filter')(question.data.objects, {type: 'condition'});

            angular.forEach(conditions, function (condition) {
                if (condition.data.targets[0].type === "questionnaire") {
                    if (condition.data.sources[0].data.id == parseInt(question.response)) {
                        question.conditions = condition.data.targets[0];
                    } else {
                        question.conditions = null;
                    }
                }
            });
        }

        /**
         *  getQuestionProperties retourne les propriétés d'une question (comme ses règles de validation ou le nom de la directive).
         */
        function getQuestionProperties(question) {
            var type = parseInt(question.data.type);
            var parameter = $filter('filter')(question.data.objects, {type: 'parameter'});
            var isBeforeAfter = parameter[0].data.beforeAfter;
            var properties = factory._getPropertiesArray(isBeforeAfter);

            if (angular.isUndefined(properties[type])) {
                return {
                    rules: [], directiveName: 'error', transform: function () {
                    }
                };
            }

            return properties[type];
        }

        /**
         *  checkForError recherche les erreurs de validation d'une question en fonction de la nécessité d'y répondre.
         *
         *  Exemple:
         *    Une question est obligatoire mais non répondue => erreur.
         *    Une question n'est pas obligatoire et la case 'Ne pas répondre' est cochée => pas d'erreur.
         *    ...
         */
        function checkForError(question) {
            if (angular.isUndefined(question)) {

                return undefined;
            }

            var rules = factory.getQuestionProperties(question).rules;

            if (factory.isMandatory(question)) {

                return factory.checkRules(question, rules);
            }

            if (factory.isDoesntAnswerChecked(question)) {

                return undefined;
            }

            return factory.checkRules(question, rules);
        }

        function isAlertShown(question) {
            return (angular.isDefined(question.validator.showAlert) && question.validator.showAlert === true);
        }

        function isAnswered(question) {
            return question.haveChoiceResponse === true;
        }

        function conditionDisplay(question,checkIfCondition) {
            if(!checkIfCondition.hasOwnProperty(question.data.id)){
                return true;
            }
           return checkIfCondition[question.data.id];
        }

        function isDoesntAnswerChecked(question) {

            if ( parseInt(question.data.type) == 9 || parseInt(question.data.type) == 10 ||
                    parseInt(question.data.type) == 12 || parseInt(question.data.type) == 18
            ) {

                var isCheked = ( Object.keys(question.doesntAnswerInputChecked).length === 0 ) ? false : true;
                var objectives = $filter('filter')(question.data.objects, {type: _composedQuestionType()[question.data.type]});
                angular.forEach(objectives, function (objective) {
                    if ( question.doesntAnswerInputChecked[objective.data.id] == false && (!question.response || !question.response.hasOwnProperty(objective.data.id) )) {
                        isCheked = false;
                    }
                });

            } else {
                 isCheked = Object.keys(question.doesntAnswerInputChecked).length > 0 && question.doesntAnswerInputChecked[question.data.id];
            }

            return isCheked;
        }

        function isMandatory(question) {
            return question.data.objects[0].data.nonActivable == '0';
        }

        /**
         *  fonction preValidate par défaut.
         */
        /* istanbul ignore next */
        function preValidate() {
            return {
                goNext: true
            };
        }

        function _isBeforeAfter(question) {
            var typeQuestion = parseInt(question.data.type);

            return (typeQuestion === QuestionConstants.BEFORE_AFTER_SCALE || typeQuestion === QuestionConstants.SCALE_OBJECTIVES && question.data.objects[0].data.beforeAfter === 1);
        }

        function _composedQuestionType() {
            return {
                 9 : 'commitment',
                10 : 'objective',
                12 : 'trainer',
                18 : 'sequence'
            }
        }
        /**
         *  isTerminated permet de savoir si doValidation est déclenché par le click sur le bouton "Valider"
         */
        function setHaveResponseForQuestion(question, isTerminated) {


            question.haveChoiceResponse = (angular.isDefined(question.response) && question.response !== -1 && question.response !== null);

            //if (question.data.objects[0].data.nonActivable == "1" && isDoesntAnswerChecked(question)) {
            if ($filter('filter')(question.data.objects, { type: 'parameter' })[0].data.nonActivable == "1" && isDoesntAnswerChecked(question)) {
                question.haveChoiceResponse = false;

            } else {
                // permet de vérifier que la réponse a été rempli pour before et after
                if (question.haveChoiceResponse && isTerminated) {
                    var nbReponseAttendues = ( factory._isBeforeAfter(question) ) ? 2 : 1;
                    // pour les questions objectives, on multiplie le nombre de réponse voulue par le nombre d'objectifs
                    if (question.data.type == 9 || question.data.type == 10 || question.data.type == 12 || question.data.type == 18) {
                        var nbObjectifs = 0;

                        angular.forEach(question.data.objects, function (element) {
                            // on récupère le nombre d'objectifs qui ont reçu une réponse
                            if (element.type == _composedQuestionType()[question.data.type] &&
                                (Object.keys(question.doesntAnswerInputChecked).length == 0 || question.doesntAnswerInputChecked[element.data.id] == false)) {
                                nbObjectifs++;
                            }
                            // on récupère les objectifs pour lesquels le participant n'a pas voulu répondre
                            if (element.type == _composedQuestionType()[question.data.type] &&
                                (Object.keys(question.doesntAnswerInputChecked).length > 0 && question.doesntAnswerInputChecked[element.data.id] == true)) {
                                nbObjectifs++;
                            }
                        });
                        nbReponseAttendues *= nbObjectifs;
                    }

                    // @TODO conditionelle fait a larache. A refaire proprement
                    if ( question.data.type != 3 && question.data.type != 4 && question.data.type != 5 && question.data.type != 19 && question.data.type != 6 && question.data.type != 7 && question.data.type != 17 && question.data.type != 15 && question.data.type != 8) {
                        angular.forEach(question.response, function (element, key) {
                            if ( element === false ) {
                                delete question.response[key];
                            }
                        });

                        if(question.data.type == 10) {
                            __getResponsesForBeforeAfterObjectives(question, nbReponseAttendues);
                        } else if ( question.data.type == 9 || question.data.type == 12 || question.data.type == 18 ) {
                            var nbReponses = 0;
                            if(angular.isDefined(question.doesntAnswerInputChecked) && question.doesntAnswerInputChecked.length) {
                                angular.forEach(question.doesntAnswerInputChecked, function (element, key) {
                                    if(factory._isBeforeAfter(question) && key.indexOf('-before') === -1 && key.indexOf('-after') === -1) {
                                        nbReponses += 2;
                                        return;
                                    }
                                    if ( element == true  || angular.isDefined(question.response[key])) {
                                        nbReponses++;
                                    }
                                });
                            } else {
                                nbReponses = Object.keys(question.response).length;
                            }
                            question.haveChoiceResponse = nbReponses == nbReponseAttendues;
                        }
                        else {
                          question.haveChoiceResponse = Object.keys(question.response).length == nbReponseAttendues;
                        }
                    } else if (question.data.type == 4 || question.data.type == 5 || question.data.type == 6 || question.data.type == 7 || question.data.type == 17) {

                        question.haveChoiceResponse = Object.keys(question.response).length > 0;
                    } else if ( question.data.type == 15 ) {

                        question.haveChoiceResponse = (question.response != null && Object.keys(question.response).length > 0) ? true : false;
                    }
                    else {
                        question.haveChoiceResponse = (question.response != null) ? true : false;

                    }
                }
            }

            return question;
        }

        function __getResponsesForBeforeAfterObjectives(question, nbReponseAttendues)
        {
            var responses = new Array();
            if(angular.isDefined(question.doesntAnswerInputChecked)) {
                var beforeAfter = factory._isBeforeAfter(question);
                angular.forEach(question.doesntAnswerInputChecked, function (element, key) {
                    if(beforeAfter && key.indexOf('before') === -1 &&  key.indexOf('after') === -1  && element) {
                        responses[key + '-before'] = element;
                        responses[key + '-after'] = element;
                    }
                });
                angular.forEach(question.response, function (element, key) {
                    if(angular.isUndefined(responses[key])) {
                        responses[key] = element;
                    }
                });
            }

            question.haveChoiceResponse = Object.keys(responses).length == nbReponseAttendues;
        }
        /**
         *    doValidation déclenche, pour une question, le processus de pre-validation puis la validation elle-même.
         *    isTerminated permet de savoir si doValidation est déclenché par le click sur le bouton "Valider"
         */
        function doValidation(question, isTerminated) {

            isTerminated = angular.isDefined(isTerminated) ? isTerminated : true;

            question = factory.setHaveResponseForQuestion(question, isTerminated);
            // fix pour les questions des questionnaires conditionnés (niveau 1 IBP)
            var preValidation = angular.isDefined(question.preValidate) ? question.preValidate() : factory.preValidate();

            if (!preValidation.goNext) {
                return question;
            }

            question = factory.validate(question);



            return question;
        }

        function doTransformation(question, parameters) {
            var transformResponses = factory.getQuestionProperties(question).transformResponses;

            question.transformedResponseForApi = formatResponsesFactory.format(question, transformResponses, parameters);

            return question;

        }

        function validate(question) {
            var error = factory.checkForError(question);

            if (angular.isUndefined(error)) {
                question.validator.isValid = true;
                question.validator.message = {};

                // Supprime le toaster existant
                if (factory.isAlertShown(question)) {
                    question = alertsFactory.remove(question);
                }

                // Récupére les conditions d'une question de niveau 1
                if (parseInt(question.data.type) === QuestionConstants.FOR_SUBJECT) {
                    factory._getQuestionConditions(question);
                }

                return question;
            }

            question.validator.isValid = false;
            question.validator.message = error;

            if (!factory.isAlertShown(question)) {
                question = alertsFactory.show(question);
            }

            return question;
        }
    }
})();

(function () {
  'use strict';
  
  angular
    .module('respondentClient')
    .factory('logformFactory', logformFactory);
  
  function logformFactory($filter, alertsFactory) {
    
    var logformFactory = {
      validate: validate
    };
    return logformFactory;
    
    function validate(inputs, type) {
      switch (type) {
        case 'all':
          return _validateAll(inputs);
        case 'registered_required':
          return _validateRegisteredRequired(inputs);
        case 'registered_only':
          return _validateRegisteredOnly(inputs);
      }
    }
    
    function _validateAll(inputs) {
      var givenInputs = [];
      
      for (var propertyName in inputs) {
        
        if(inputs.hasOwnProperty(propertyName)) {
          if (inputs[propertyName].value === '') {
            givenInputs.push(inputs[propertyName]);
          }
        }
      }
  
      if (givenInputs.length === 0 || givenInputs.length === 3) {
        return true;
      } else {
        givenInputs.forEach(function (el) {
          alertsFactory.show(el, 'mandatoryAccess');
        });
        return false;
      }
    }
    
    function _validateRegisteredRequired(inputs) {
      var givenInputs = [];
  
      for (var propertyName in inputs) {
    
        if(inputs.hasOwnProperty(propertyName)) {
          if (inputs[propertyName].value === '') {
            givenInputs.push(inputs[propertyName]);
          }
        }
      }
  
      if (givenInputs.length === 3) {
        return true;
      } else {
        givenInputs.forEach(function (el) {
          alertsFactory.show(el, 'mandatoryAccess');
        });
        return false;
      }
    }
    
    function _validateRegisteredOnly() {
    
    }
    
  }
  
})();

(function() {
    'use strict';

    angular
        .module('respondentClient')
        .factory('formatResponsesFactory', formatResponsesFactory);

    function formatResponsesFactory($filter, QuestionConstants, FilterType) {
        var questionObject = {};
        var transformResponseObject;
        var parametersObject = {};
        var responseObject, scaleObject, scaleId, isBeforeAfter, questionParams, answers;

        var formatResponsesFactory = {
            _buildAnswersByTypeOfQuestion: _buildAnswersByTypeOfQuestion,
            _buildChoicesResponse: _buildChoicesResponse,
            _buildGlobalAnswersObjects: _buildGlobalAnswersObjects,
            _buildResponseScale: _buildResponseScale,
            _buildResponseToScaleElement: _buildResponseToScaleElement,
            _buildScaleToElementResponseObject: _buildScaleToElementResponseObject,
            _initElementsForResponsesObjects: _initElementsForResponsesObjects,
            _initResponseObject: _initResponseObject,
            _initResponseScale: _initResponseScale,
            _isMandatory: _isMandatory,
            format: format,
            transformAssociative: transformAssociative,
            transformComitmentAchieving: transformComitmentAchieving,
            transformForSubject: transformForSubject,
            transformFreeText: transformFreeText,
            transformMultipleChoice: transformMultipleChoice,
            transformObjectiveScale: transformObjectiveScale,
            transformOrderlyResponse: transformOrderlyResponse,
            transformPreference: transformPreference,
            transformRecommendationRateScale: transformRecommendationRateScale,
            transformScale: transformScale,
            transformSequenceScale: transformSequenceScale,
            transformTrainerScale: transformTrainerScale,
            transformUniqueChoice: transformUniqueChoice
        };

        return formatResponsesFactory;

        function _initElementsForResponsesObjects(question, transformResponse, parameters) {
            responseObject = {};
            questionObject = question;
            transformResponseObject = transformResponse;
            parametersObject = parameters;
            responseObject.data = {};
        }

        function format(question, transformResponse, parameters) {
            formatResponsesFactory._initElementsForResponsesObjects(question, transformResponse, parameters);

            var response = transformResponseObject.method();

            return response;
        }

        function _initResponseScale() {
            questionParams = $filter('filter')(questionObject.data.objects, {
                type: FilterType.PARAMETER
            });
            isBeforeAfter = questionParams[0].data.beforeAfter;
            scaleObject = $filter('filter')(questionObject.data.objects, {
                type: FilterType.SCALE
            });
            scaleId = scaleObject[0].data.id;
            responseObject.data.beforeAfter = isBeforeAfter;
        }

        /**
         *    _isMandatory vérifie qu'une question nécessite une réponse.
         */
        function _isMandatory(question) {
            if (question.data.type == QuestionConstants.FREE_TEXT) {
                return false;
            }

            if (question.data.type == QuestionConstants.RECOMMENDATION_RATE) {
                return true;
            }

            /**** a supprimer apres test***/
            /*if (question.data.checkScaleisNull) {
                return false;
            }*/


            return question.data.objects[0].data.nonActivable === "0";
        }

        function _initResponseObject() {
            answers = [];
            responseObject.type = transformResponseObject.responsesType;
            responseObject.data.questionId = questionObject.data.id;
            responseObject.data.questionVersion = questionObject.data.versionNumber;
            responseObject.data.questionnaireId = parametersObject.questionnaireId;
            responseObject.data[transformResponseObject.responseObjectName] = [];
            responseObject.data.mandatory = formatResponsesFactory._isMandatory(questionObject);
        }

        function _buildGlobalAnswersObjects(answersObjects) {
            responseObject.data[transformResponseObject.responseObjectName] = answersObjects;
        }

        function _buildAnswersByTypeOfQuestion() {
            formatResponsesFactory._initResponseObject();

            var obj = {
                haveResponse: questionObject.haveChoiceResponse & 1,
                measureId: parametersObject.measureId,
                userId: parametersObject.participantUserName
            };

            if (parametersObject.referenceId != 0) {
                obj.traineeId = parametersObject.referenceId;
            }

            responseObject.data[transformResponseObject.responseObjectName].push(obj);
        }

        function transformScale() {

            formatResponsesFactory._initResponseScale();
            formatResponsesFactory._initResponseObject();

            var params = {};
            params.keyPosition = 0;
            answers.push(formatResponsesFactory._buildResponseScale(params));

            if (isBeforeAfter) {
                params.keyPosition = 1;
                answers.push(formatResponsesFactory._buildResponseScale(params));
            }

            formatResponsesFactory._buildGlobalAnswersObjects(answers);

            return responseObject;
        }

        function _buildResponseScale(params) {


            var responseScales = {
                haveResponse: questionObject.haveChoiceResponse & 1,
                measureId: parametersObject.measureId,
                userId: parametersObject.participantUserName,
                scaleId: parseInt(scaleId)
            };

            if (parametersObject.referenceId != 0) {
                responseScales.traineeId = parametersObject.referenceId;
            }

            if (isBeforeAfter) {
                responseScales.after = params.keyPosition;
            }

            if ( questionObject.doesntAnswerInputChecked === false
                || Object.keys(questionObject.doesntAnswerInputChecked).length === 0
                || questionObject.doesntAnswerInputChecked[questionObject.data.id] === false) {
                var elementIdToResponse = questionObject.data.id;

                if (angular.isDefined(responseScales.after)) {
                    elementIdToResponse = (params.keyPosition === 0) ? elementIdToResponse + '-before' : elementIdToResponse + '-after';
                }

                responseScales.degree = questionObject.response[elementIdToResponse];
            }

            if (questionObject.comment !== null && angular.isDefined(questionObject.comment[questionObject.data.id])
                && (responseScales.after === 0 || angular.isUndefined(responseScales.after))
            ) {
                responseScales.comment = questionObject.comment[questionObject.data.id];
            }

            return responseScales;
        }

        function transformObjectiveScale() {
            /** checkScaleisNull si objectifs scale est different de nul on envoit responseObjets à l'api sinon vide (undefined)  */
            if(!questionObject.data.checkScaleisNull){
            formatResponsesFactory._initResponseObject();
            formatResponsesFactory._initResponseScale();
            formatResponsesFactory._buildResponseToScaleElement({
                target: FilterType.OBJECTIVE
            });
            formatResponsesFactory._buildGlobalAnswersObjects(answers);
            return responseObject;

        }
        }

        function transformComitmentAchieving() {
            formatResponsesFactory._initResponseObject();
            formatResponsesFactory._initResponseScale();
            formatResponsesFactory._buildResponseToScaleElement({
                target: FilterType.COMMITMENT
            });
            formatResponsesFactory._buildGlobalAnswersObjects(answers);

            return responseObject;
        }

        function transformRecommendationRateScale() {
            formatResponsesFactory._buildAnswersByTypeOfQuestion();

            responseObject.data[transformResponseObject.responseObjectName][0].value = questionObject.response[questionObject.data.id];

            if (questionObject.comment && angular.isDefined(questionObject.comment[questionObject.data.id])) {
                responseObject.data[transformResponseObject.responseObjectName][0].comment = questionObject.comment[questionObject.data.id];
            }

            return responseObject;
        }

        function transformSequenceScale() {
            formatResponsesFactory._initResponseObject();
            formatResponsesFactory._initResponseScale();
            formatResponsesFactory._buildResponseToScaleElement({
                target: FilterType.SEQUENCE
            });
            formatResponsesFactory._buildGlobalAnswersObjects(answers);

            return responseObject;
        }

        //création de la réponse pour question de type scale, avec activation de NSP
        function _buildResponseToScaleElement(params) {
            var elements = $filter('filter')(questionObject.data.objects, { type: params.target });

            elements.forEach(function(element) {
                params.element = element;
                params.keyPosition = 0;
                answers.push(formatResponsesFactory._buildScaleToElementResponseObject(params));

                if (params.target === FilterType.OBJECTIVE && isBeforeAfter) {
                    params.keyPosition = 1;
                    answers.push(formatResponsesFactory._buildScaleToElementResponseObject(params));
                }
            });
        }

        function _buildScaleToElementResponseObject(params) {
            var answerObject = {
                haveResponse: questionObject.haveChoiceResponse & 1,
                measureId: parametersObject.measureId,
                userId: parametersObject.participantUserName,
                scaleId: parseInt(scaleId)
            };

            if (parametersObject.referenceId != 0) {
                answerObject.traineeId = parametersObject.referenceId;
            }




            //TODO améliorer ce switch
            switch (params.target) {
                case FilterType.OBJECTIVE:
                    answerObject.objectiveId = parseInt(params.element.data.id);

                    if (isBeforeAfter) {
                        answerObject.after = params.keyPosition;
                        // permet de gérer le haveResponse sur un objectif en particulier
                        answerObject.haveResponse = parseInt(!questionObject.doesntAnswerInputChecked[params.element.data.id]) & 1;
                    }
                    break;
                case FilterType.SEQUENCE:
                    answerObject.sequenceId = params.element.data.id;
                    break;
                case FilterType.COMMITMENT:
                    answerObject.commitmentId = params.element.data.id;
                    break;
                case FilterType.TRAINING_ORGANIZATION:
                case FilterType.TRAINER:
                    answerObject.trainingOrganizationId = params.element.data.trainingOrganizationId;

                    if (params.element.type === FilterType.TRAINER) {
                        answerObject.trainerId = params.element.data.userName;
                    }
                    break;
                default:

                    break;
            }

            var elementIdToResponse = params.element.data.id;

            if (isBeforeAfter) {
                elementIdToResponse = (params.keyPosition === 0) ? elementIdToResponse + '-before' : elementIdToResponse + '-after';
            }

            //TODO factoriser
            if ( angular.isUndefined(questionObject.doesntAnswerInputChecked[params.element.data.id])
                || questionObject.doesntAnswerInputChecked[params.element.data.id] === false) {
                answerObject.degree = questionObject.response[elementIdToResponse];
                answerObject.haveResponse = 1;
            }

            if ( !isBeforeAfter || params.keyPosition === 0 ) {
                answerObject.comment = (questionObject.comment === null || angular.isUndefined(questionObject.comment[elementIdToResponse])) ? null : questionObject.comment[elementIdToResponse];
            }

            if(params.target == FilterType.OBJECTIVE && isBeforeAfter && params.keyPosition === 0) {
                var id = parseInt(questionObject.data.id) + '-' + params.element.data.id;
                // id de la forme: questionId-objectifId
                answerObject.comment = (questionObject.comment === null || angular.isUndefined(questionObject.comment[id])) ? null : questionObject.comment[id];
            }

            return answerObject;
        }

        function transformTrainerScale() {
            formatResponsesFactory._initResponseObject();
            formatResponsesFactory._initResponseScale();
            formatResponsesFactory._buildResponseToScaleElement({
                target: FilterType.TRAINING_ORGANIZATION
            });
            formatResponsesFactory._buildResponseToScaleElement({
                target: FilterType.TRAINER
            });
            formatResponsesFactory._buildGlobalAnswersObjects(answers);

            return responseObject;
        }

        function transformUniqueChoice() {
            formatResponsesFactory._buildAnswersByTypeOfQuestion();

            if (Object.keys(questionObject.doesntAnswerInputChecked).length == 0 || questionObject.doesntAnswerInputChecked[questionObject.data.id] === false) {
                responseObject.data[transformResponseObject.responseObjectName][0].choiceId = questionObject.response;
            }

            if (questionObject.comment && angular.isDefined(questionObject.comment[questionObject.data.id])) {
                responseObject.data[transformResponseObject.responseObjectName][0].comment = questionObject.comment[questionObject.data.id];
            }

            return responseObject;
        }

        function transformMultipleChoice() {
            formatResponsesFactory._buildAnswersByTypeOfQuestion();
            formatResponsesFactory._buildChoicesResponse({ target: FilterType.MULTIPLE_CHOICES });

            if (questionObject.comment && questionObject.comment[questionObject.data.id] != undefined) {
                responseObject.data[transformResponseObject.responseObjectName][0].comment = questionObject.comment[questionObject.data.id];
            }

            return responseObject;
        }

        function _buildChoicesResponse(params) {
            var elements = [];
            //TODO améliorer éventuellement ce paramétrage peu dynamique
            var responseAttribut = (params.target === FilterType.ASSOCIATION_CHOICES) ? 'associations' : 'choices';
            if (Object.keys(questionObject.doesntAnswerInputChecked).length == 0
               || questionObject.doesntAnswerInputChecked[questionObject.data.id] == false) {
                angular.forEach(questionObject.response, function(value, key) {
                    var currentElement = {};

                    switch (params.target) {
                        case FilterType.MULTIPLE_CHOICES:
                            currentElement.id = key;
                            break;
                        case FilterType.ORDERLY_CHOICES:
                        case FilterType.PREFERENCE_CHOICES:
                            currentElement.id = value.data.id;
                            currentElement.order = key + 1;
                            break;
                        case FilterType.ASSOCIATION_CHOICES:
                            currentElement.source = parseInt(value.leftLink);
                            currentElement.target = parseInt(value.rightLink);
                            break;
                    }

                    if (value) {
                        elements.push(currentElement);
                    }
                });
            }
            responseObject.data[transformResponseObject.responseObjectName][0][responseAttribut] = elements;
        }

        function transformOrderlyResponse() {
            formatResponsesFactory._buildAnswersByTypeOfQuestion();
            formatResponsesFactory._buildChoicesResponse({ target: FilterType.ORDERLY_CHOICES });

            return responseObject;
        }

        function transformPreference() {
            formatResponsesFactory._buildAnswersByTypeOfQuestion();
            formatResponsesFactory._buildChoicesResponse({ target: FilterType.PREFERENCE_CHOICES });

            if (questionObject.comment && angular.isDefined(questionObject.comment[questionObject.data.id])) {
                responseObject.data[transformResponseObject.responseObjectName][0].comment = questionObject.comment[questionObject.data.id];
            }

            return responseObject;
        }

        function transformAssociative() {
            formatResponsesFactory._buildAnswersByTypeOfQuestion();
            formatResponsesFactory._buildChoicesResponse({ target: FilterType.ASSOCIATION_CHOICES });

            return responseObject;
        }

        function transformFreeText() {
            // les réponses aux questions libres vides ne sont pas envoyés.
            //if(questionObject.response) {
                formatResponsesFactory._buildAnswersByTypeOfQuestion();
                responseObject.data[transformResponseObject.responseObjectName][0].freetext = questionObject.response;
            //}
            return responseObject;
        }

        function transformForSubject() {
            formatResponsesFactory._buildAnswersByTypeOfQuestion();
            responseObject.data[transformResponseObject.responseObjectName][0].choiceId = questionObject.response;

            return responseObject;
        }


    }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .factory('formatJsonSurveyFactory', formatJsonSurveyFactory);

  function formatJsonSurveyFactory($filter,ToolsFactory,QuestionObjectFactory) {

    var formatJsonSurveyFactory = {
      format: format
    };
    return formatJsonSurveyFactory;

    function format(json, conditionalOption) {
      var conditional = conditionalOption || false;
      var jsonFinal = [];
      var listOfSurveys;

      jsonFinal.surveys = [];
      if (!conditional) {
        jsonFinal.summary = getJsonSummary(json);
        listOfSurveys = json;
      } else {
        listOfSurveys = getSurveysListForConditionnal(json);
      }

      angular.forEach(listOfSurveys.list, function (value) {
        var surveyDetails = {
          'id': value.data.id,
          'lastUpdatedDate': value.data.lastUpdatedDate,
          'name': value.data.name,
          'langId': value.data.langId,
          'typeId': value.data.typeId,
          'elementNumber': value.data.elementNumber,
          'answered': 0,
          'pages': []
        };
        var pages = $filter('filter')(value.data.objects, {type: 'page'});
        angular.forEach(pages, function (page) {
          var elements = page.data.objects;
          var elementsByPage = [];
          angular.forEach(elements, function (ele) {
            if (ele.type === 'question') {
              // pour la question asscoiation on randomize les choice à la reception des résultats
                // TODO bouger ça dans la questionObjectFactory : un comportement spécifique sur un
                // type donné n'a rien à faire ici
              if(ele.data.type == "17"){
                ele.data.objects = ToolsFactory.randomizeObjects(ele.data.objects);
              }

              var questionObject = QuestionObjectFactory.build(ele, listOfSurveys.answers);
              elementsByPage.push(questionObject);
            } else {
              elementsByPage.push(ele);
            }
          });
          surveyDetails.pages.push(elementsByPage);

        });
        jsonFinal.surveys.push(surveyDetails);
      });
      return jsonFinal;
    }


    function getJsonSummary(json) {
      var summaryDetails = {};
      
      angular.forEach(json.list[0], function (values) {

        angular.forEach(values.objects, function (value) {
          if (value.type == 'project') {
            summaryDetails.trainingTitle = value.data.title;
            summaryDetails.sessionTitle = value.data.objects.data.name;
            summaryDetails.trainers = getTrainers(value.data.objects.data.objects[0].data.objects);
            summaryDetails.labelsForSummary = _getLabelsOfSummary(value.data.type);
          }
        });

      });

      return summaryDetails;
    }

    function getTrainers(trainingOrganizationObjects) {
      var trainers = [];
        if (angular.isArray(trainingOrganizationObjects)) {
            
            angular.forEach(trainingOrganizationObjects, function (trainingOrganizationObject) {
                var trainingOrganization = {};
                if(trainingOrganizationObject.type != null &&
                    trainingOrganizationObject.type == 'trainingOrganization'
                    && trainingOrganizationObject.data.title != null) {
                    trainingOrganization.title = trainingOrganizationObject.data.title;
                    trainingOrganization.trainers = [];
            // plus d'un formateur
                    if(trainingOrganizationObject.data.objects != null &&
                        trainingOrganizationObject.data.objects.length > 0) {
                        angular.forEach(trainingOrganizationObject.data.objects, function (trainerObject) {
                            if(trainerObject.type != null && trainerObject.type == 'trainer' && trainerObject.data.id != 0 )  {
                                trainingOrganization.trainers.push(trainerObject.data.firstname + ' ' + trainerObject.data.lastname);
                            }
                        });
                    } else if( trainingOrganizationObject.data.objects.type != null &&
                        trainingOrganizationObject.data.objects.type == 'trainer' &&
                        trainingOrganizationObject.data.objects.data.id != 0){
                        // un seul formateur
                        trainingOrganization.trainers.push(trainingOrganizationObject.data.objects.data.firstname + ' ' + trainingOrganizationObject.data.objects.data.lastname);
                    }
                    trainers.push(trainingOrganization);
                }
            });
        }
      return trainers;
    }

    function getSurveysListForConditionnal(json) {
      var returnedJson = {list: []};
      angular.forEach(json.list, function (value) {
        var key = Object.keys(value);
        returnedJson.list.push(value[key[0]]);
      });
      return returnedJson;
    }

    function _getLabelsOfSummary(projectType) {
      var labelsSummary = {"TrainingLabel": "", "sessionLabel": ""};
      switch (projectType) {
        case 'analysis':
          labelsSummary.TrainingLabel = "TRAINING_ANALYSIS";
          labelsSummary.sessionLabel = "SESSION_ANALYSIS";
          break;
        default :
          labelsSummary.TrainingLabel = "TRAINING";
          labelsSummary.sessionLabel = "SESSION";
          break;
      }
      return labelsSummary;
    }


  }

})();


(function () {
	'use strict';

	angular
		.module('respondentClient')
		.directive('survey', survey);

	function survey() {
		var directive = {
			restrict: 'E',
			scope: {
				surveys: '=',
				parameters: '=',
				summary: '='
			},
			templateUrl: 'app/views/directives/questionnaire/questionnaire.html',
			controller: 'SurveyDirectiveController',
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;
	}
})();

(function() {
    'use strict';
    angular.module('respondentClient')
        .directive('registerform', registerform);

    function registerform() {
        return {
            restrict: 'E',
            scope: {
                infos: '='
            },
            templateUrl: "app/views/partials/register/registerform.html",
            replace: true,
            transclude: true,
            controller: 'RegisterFormController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('page', function () {
      return {
        restrict: 'E',
        scope: {
          page: '='
        },
        replace: false,
        transclude: true,
        templateUrl: "app/views/directives/questionnaire/page.html",
        controller: pageController,
        controllerAs: 'vm',
        bindToController: true
      };
      function pageController() {
      }
    });
})();

(function () {
  'use strict';
  angular.module('respondentClient')
    .directive('element', function ($compile) {
      return {
        restrict: 'E',
        scope: {
          element: '='
        },
        replace: true,
        transclude: true,
        link: linkElement
      };

      function linkElement(scope, ele) {
        var element = scope.element;
        var generatedTemplate = "<" + element.type + "-element element=\"element\"  ></" + element.type + "-element>";
        ele.append(generatedTemplate);
        $compile(ele.contents())(scope);
      }


    });
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .controller('SurveysController', SurveysController);

  /** @ngInject */
  function SurveysController($scope,$rootScope,loginService, logoService, configuration, surveysService, localStorageFactory, $stateParams, formatJsonSurveyFactory, surveysFactory, ipCookie, $location) {

    var vm = this;
    var isOperaMini = (navigator.userAgent.indexOf('Opera Mini') > -1);
    /**
     * Appel au constructor
     */
    __construct();
    /**
     *
     * @private
     */
    function __construct() {
      if ($stateParams.surveyHash == "" || $stateParams.surveyHash == undefined) {
        $location.path('/404');
      }

      vm.surveyHash = $stateParams.surveyHash;
      vm.loading = $rootScope.suerveysCharged = true;
      vm.logo = null;

      vm.prefix = configuration.prefix_org;

      //vm.surveysFormatted  = [];
      if (ipCookie(vm.surveyHash) == undefined) {
        loginService.login().then(function (response) {
          if (response.status == 200) {
            vm.measureId = response.data.data.measureId;
            ipCookie(vm.surveyHash, angular.toJson(response.data), {expirationUnit: 'minutes', expires: 60});
            _getSurveys(response.data);
          }
        });
      } else {
        vm.measureId = ipCookie(vm.surveyHash).data.measureId;
        _getSurveys();
      }
    }

    /**
     * Récupère les questionnaire depuis N-API
     */
    function _getSurveysAPI() {
      var cookiesDetails = angular.fromJson(ipCookie(vm.surveyHash));

      surveysService
        .getList()
        .then(function (response) {
          if (response.status == 200) {
            var listQuestionnaires = response.data;
            vm.surveysFormatted = formatJsonSurveyFactory.format(listQuestionnaires);
            var participantUserName = cookiesDetails.data.userName;
            var referenceId = cookiesDetails.data.referenceId;
            vm.parameters = {
              measureId: vm.measureId,
              participantUserName: participantUserName,
              referenceId: referenceId
            };
            if (!isOperaMini) {
              localStorageFactory.save(vm.surveyHash, {
                surveys: vm.surveysFormatted.surveys,
                summary: vm.surveysFormatted.summary,
                parameters: vm.parameters
              });
            }
          }
          vm.loading = false;
      });
    }

    /**
     * Récupère le questionnaire depuis le local storage, en vérifiant si celui-ci est à jour
     * Si pas de questionnaire dans le local storage, va le récupérer depuis N-API
     */
    function _getSurveys(cookieContent) {
      logoService.getLogo().then(function (response) {
        vm.logo = response;
        var cookiesDetails;
        // Sometimes we don't have the cookie even if it seems it was created before
        if (angular.isUndefined(ipCookie(vm.surveyHash)) && angular.isDefined(cookieContent)) {
            cookiesDetails = cookieContent;
        }
        else {
            cookiesDetails = angular.fromJson(ipCookie(vm.surveyHash));
        }

        // si l'evaluation est publique
        if(angular.isDefined(cookiesDetails.data.measureAccess)){
            $location.path( "/users/register/" + vm.surveyHash + "/" + vm.prefix );
        }

        if (localStorageFactory.get(vm.surveyHash) && !isOperaMini) {
        surveysService
          .getListDate()
          .then(function (response) {
            // on vérifie que le questionnaire dans le local storage est à jour

            vm.surveysFormatted = angular.fromJson(localStorageFactory.get(vm.surveyHash));
            var isUptoDate = surveysFactory.localStorageIsUpToDate(response.data, vm.surveysFormatted.surveys);

            if(isUptoDate) {
              vm.surveysFormatted = angular.fromJson(localStorageFactory.get(vm.surveyHash));
              vm.loading = false;
            } else {
              // chargement du nouveau questionnaire

              // Note: Pas de suppression du local storage,
              // sinon fait planter SurveyDirectiveController
              _getSurveysAPI();
            }
          });
        } else {
          _getSurveysAPI();
        }
      }, function (err) {
          if (err.status == 403 || err.status == 401) {
            ipCookie.remove(vm.surveyHash);
            loginService.login().then(function (response) {
              if (response.status == 200) {
                vm.measureId = response.data.data.measureId;
                ipCookie(vm.surveyHash, angular.toJson(response.data), {expirationUnit: 'minutes', expires: 60});
                _getSurveys();
              }
            });
          }
      });

      $scope.$watch('vm.loading', function(isFalse){
        if (isFalse) {
          $scope.$broadcast('rzSliderForceRender');
        }
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('respondentClient')
        .controller('RegisterFormController', RegisterFormController);

    function RegisterFormController($http, configuration, $scope, initTemplateFactory, cssInjector, registerformFactory, registerformService, alertsFactory, $location, $stateParams, ipCookie, UsersService, loginService, logoService) {
        var vm = this;
        vm.logo;

        logoService
            .getLogo()
            .then(function(logo) {
                vm.logo = logo;
            });

        __initializeMeasure();

        function __initializeMeasure() {
            vm.firstnames = [];
            vm.lastnames = [];
            vm.surveyHash = $stateParams.surveyHash;

            if (angular.isUndefined(ipCookie(vm.surveyHash))) {
                loginService
                    .login()
                    .then(function(response) {
                        ipCookie(vm.surveyHash, angular.toJson(response.data), { expirationUnit: 'minutes', expires: 60 });
                        vm.infos = response.data;
                        __construct();
                    });
            } else {
                vm.infos = ipCookie(vm.surveyHash);
                __construct();
            }
        }

        function __construct() {
            vm.measureId = vm.infos.data.measureId;
            vm.EXPLAIN_MODUS = "EXPLAIN_MODUS_" + vm.infos.data.measureAccess;
            vm.register = register;
            vm.finalMessageValidation = {};
            vm.finalMessageValidation.success = false;
            vm.finalMessageValidation.error = false;
            vm.inputs = {
                fname: { value: '', validator: {}, target: 'fname', message: 'FNAME_IS_MANDATORY' },
                lname: { value: '', validator: {}, target: 'lname', message: 'LNAME_IS_MANDATORY' }
            };

            if (vm.infos.data.measureAccess !== 'register_only') {
                vm.inputs.email = { value: '', validator: {}, target: 'email', message: 'EMAIL_IS_MANDATORY' }
            }


            UsersService
                .getFirstAndLastNames(ipCookie(vm.surveyHash).data.measureId, vm.surveyHash)
                .then(function(response) {
                    // firstnames and lastnames are interchanged
                    vm.firstnames = response.lastnames;
                    vm.lastnames = response.firstnames;
                });
        }

        function register() {
            if (registerformFactory.validate(vm.inputs, vm.infos.data.measureAccess)) {
                var lastName = (vm.inputs.lname.value.text != undefined) ? vm.inputs.lname.value.text : vm.inputs.lname.value;
                var firstName = (vm.inputs.fname.value.text != undefined) ? vm.inputs.fname.value.text : vm.inputs.fname.value;
                var user = {
                    'lastName': lastName,
                    'firstName': firstName
                };

                if (vm.infos.data.measureAccess === 'register_only') {
                    var flname = user.lastName + user.firstName;
                    registerformService.get(flname).then(function(response) {
                        if (response.status === 200 ) {
                            if(registerformFactory._existsInOrganization(response.data)) {
                                if (angular.isUndefined(response.data.data)) {
                                    vm.finalMessageValidation = { text: response.data.results.message, success: false };
                                    vm.finalMessageValidation.error = true;
                                    alertsFactory.show({ message: vm.finalMessageValidation.text }, 'success');
                                } else {
                                    var surveyHash = response.data.data[0].link_to_measure;
                                    $location.path('/surveys/' + surveyHash + '/' + $stateParams.organization);
                                }
                            } else {
                                vm.finalMessageValidation = { text: 'ERROR_REGISTER_NAME', success: false, error: true };
                                alertsFactory.show({ message: vm.finalMessageValidation.text }, 'warning');
                            }
                        } else {
                            vm.finalMessageValidation = { text: 'ERROR_GET_SURVEYHASH', success: false };
                            vm.finalMessageValidation.error = true;
                            alertsFactory.show({ message: vm.finalMessageValidation.text }, 'warning');
                        }

                    });
                } else {
                    user.email = vm.inputs.email.value;
                    registerformService.post(user).then(function(response) {
                        if (response.status === 200) {
                            var surveyHash = response.data.surveyHash;
                            vm.finalMessageValidation = { text: 'SUCCESS_REGISTER_USER', success: true };
                            alertsFactory.show({ message: vm.finalMessageValidation.text }, 'success');
                            $location.path('/surveys/' + surveyHash + '/' + $stateParams.organization);
                        } else {
                            vm.finalMessageValidation = { text: 'ERROR_REGISTER_USER', success: false };
                            vm.finalMessageValidation.error = true;
                            alertsFactory.show({ message: vm.finalMessageValidation.text }, 'warning');
                        }
                    });
                }
            }
        }

        $scope.$watch('vm.inputs', function(items) {
            for (var propertyName in items) {

                if (items.hasOwnProperty(propertyName)) {
                    if (items[propertyName].value !== '') {
                        alertsFactory.remove(items[propertyName]);
                    }
                }
            }
        }, true);
    }
})();

(function() {
    'use strict'

    angular
        .module('respondentClient')
        .constant('QuestionConstants', {
            ASSOCIATIVE: 17, // Connaissances
            BEFORE_AFTER_SCALE: 2, // Formation
            PREFERENCE: 6, // Formation
            COMITMENT_ACHIEVING: 9, // Formation
            FOR_SUBJECT: 19,
            CONDITIONNAL: 20,
            FREE_TEXT: 8, // Formation
            MULTIPLE_CHOICES: 4, // Formation
            ORDERLY_RESPONSE: 7, // Connaissances
            QUIZ: 5, // Connaissances
            RECOMMENDATION_RATE: 13, // Formation
            SCALE: 1, // Formation
            SCALE_OBJECTIVES: 10,
            SCALE_SEQUENCES: 18, // Formation
            SCALE_TRAINERS: 12, // Formation
            UNIQUE_CHOICE: 3, // Formation
            //UNIQUE_CHOICE_CONDITIONNEL: 3, // Formation
            WORD_MATCH: 15 // Connaissances,

        });
})();
(function() {
    'use strict'

    angular
        .module('respondentClient')
        .constant('FilterType', {
            COMMITMENT: 'commitment',
            OBJECTIVE: 'objective',
            PARAMETER: 'parameter',
            SCALE: 'scale',
            SEQUENCE: 'sequence',
            TRAINER: 'trainer',
            TRAINING_ORGANIZATION: 'trainingOrganization',
            MULTIPLE_CHOICES: 'multipleChoices',
            ORDERLY_CHOICES: 'orderlyChoices',
            PREFERENCE_CHOICES: 'preferenceChoices',
            ASSOCIATION_CHOICES: 'associationChoices'
        });
})();
/**
 * Created by franck on 25/11/16.
 */
(function () {
  'use strict';

  angular
    .module('respondentClient')
    .service('responsesService', responsesService);

  function responsesService($http, configuration) {
    var url = configuration.protocol_type + '//' + configuration.server_name;

    //vérificatin du login au prélable ?
    //this.login = login;


    var responsesService = {
      save: save,
      get: get,
      remove: remove
    };
    return responsesService;

    /**
     * elle prend le survey hash et appe le service survey afin de voir la validité de hash
     * @param surveyHash
     * @returns un object qui contient le code error el code message
     */

    function save(data, rawData) {
      var uri =url+'/responses';

      return $http({
        method: 'POST',
        url: uri,
        headers: {'Content-Type': 'application/json'},
        data: {data: data, rawData: rawData}
      });
    }

    function get(id) {
      var uri = url + '/responses/' + id;

      return $http({
        method: 'GET',
        url: uri,
        headers: {'Content-Type': 'application/json'}
      });
    }

    function remove(id) {
      var uri = url + '/responses/' + id;

      return $http({
        method: 'DELETE',
        url: uri,
        headers: {'Content-Type': 'application/json'}
      });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('respondentClient')
        .service('logoService', logoService);

    function logoService($http, configuration, localStorageFactory) {
        var url = configuration.protocol_type + '//' + configuration.server_name;
        this.getLogo = getLogo;

        function getLogo(surveyHash) {
            var uri = url + '/images';

            return $http({
                method: 'GET',
                url: uri,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': surveyHash
                }
            })
            .then(function(response) {
                var urlLogo = configuration.protocol_type + '//' + configuration.server_name_orgs + response.data.logo;
                localStorageFactory.save('urlLogoOrganisation', urlLogo);
                return urlLogo;
            })
            .catch(function() {
                return '/assets/images/formaevaV2.png';
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .service('loginService', loginService);

  function loginService($http,configuration) {

    var url = configuration.protocol_type + '//' + configuration.server_name;
    this.login = login;
    /**
     * elle prend le survey hash et appe le service survey afin de voir la validité de hash
     * @param surveyHash
     * @returns un object qui contient le code error el code message
     */
    function login() {
      var uri =url+'/surveyHash';
      return $http({
        method: 'GET',
        url: uri,
        cache:false,
        headers: {'Content-Type': 'application/json'}
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .filter('groupById', groupByObjectById);

  function groupByObjectById($filter) {
    return function (list) {
      var filtered = [];
      angular.forEach(list, function (item) {
        var itemObject =  {id:item.id};
        var foundItem = $filter('filter')(filtered, itemObject, true)[0];
        if (!foundItem) {
          filtered.push(item);
        }
      });
      return filtered;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .filter('countKeysObject', countKeysObject);

  function countKeysObject() {
    return function (object) {
      var keys = Object.keys(object);
        return keys.length;
    };

  }
})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.factory('ToolsFactory', function ToolsFactory() {
      var ToolsFactory = {
        exchange: exchange,
        randomizeObjects: randomizeObjects
      };
      
      return ToolsFactory;
      
      function randomizeObjects(objects) {
        return objects.sort(function() {
          return 0.5 - Math.random();
        });
      }
      
      /**
       *	exchange déplace source vers destination et destination vers source.
       */
      function exchange(array, source, destination) {
        var temp = array[source];
        array[source] = array[destination];
        array[destination] = temp;
      }
    });

	
})();

(function () {
	'use strict';

	angular
		.module('respondentClient')
		.factory('scrollFactory', scrollFactory);

	function scrollFactory($document, configuration) {
		var scrollFactory = {
			scrollToErrorElement: scrollToErrorElement,
			getFirstErrorElement: getFirstErrorElement
		};

		return scrollFactory;

		function scrollToErrorElement(elements) {
			var _firstElementError = getFirstErrorElement(elements);

			if(_firstElementError.data != undefined){
				var _elementById = angular.element(document.getElementById(_firstElementError.data.id));
				$document.scrollTo(_elementById, configuration.scrollParameter.offsets, configuration.scrollParameter.duration);
			}
		}

		function getFirstErrorElement(elements) {
			var _first = true;
			var _firstElementWithError = {};

			angular.forEach(elements, function (value) {
				if (value.type == 'question' && value.validator.isValid == false && _first) {
					_first = false;
					_firstElementWithError = value;
				}
			});

			return _firstElementWithError;
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .factory('localStorageFactory', localStorageFactory);

  function localStorageFactory(localStorageService) {

    var localStorageFactory = {
      get: get,
      save: save,
      remove: remove
    };
    return localStorageFactory;

    function get(key) {
      return localStorageService.get(key);
    }

    function save(key, value) {
      return localStorageService.set(key, value);
    }

    function remove(key) {
      localStorageService.remove(key);
    }
  }

})();


(function () {
    'use strict';

    angular
        .module('respondentClient')
        .factory('initTemplateFactory', initTemplateFactory);

    function initTemplateFactory(configuration) {
        var initTemplateFactory = {
            getCssFileToInject: getCssFileToInject,
            getCssPath: getCssPath
        };

        return initTemplateFactory;

        function getCssFileToInject() {
            var templatesForOrganizations = configuration.templatesForOrganizations;

            if (templatesForOrganizations.hasOwnProperty(configuration.prefix_org)) {
                return getCssPath(templatesForOrganizations[configuration.prefix_org]);
            }

            return getCssPath();
        }

        function getCssPath(templateName) {
            if (!templateName) {
                templateName = configuration.templatesForOrganizations.default;
            }

            return configuration.path.css + templateName + '.css';
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('respondentClient')
    .factory('httpInterceptorFactory', httpInterceptorFactory);

  function httpInterceptorFactory($q, $stateParams, $location, $rootScope) {

    var httpInterceptorFactory = {
      response: response,
      request: request,
      responseError: responseError
    }
    return httpInterceptorFactory;

    function response(response) {
      return response || $q.when(response);
    }

    function request(params) {
      params.headers = params.headers || {}
      params.headers.Authorization = $stateParams.surveyHash;
      return params;
    }

    function responseError(rejection) {
      var status = rejection.status;
      if (status == 400 || status == 404 || status == 401) {
        if (rejection.data.message != undefined) {
          $rootScope.messageError = rejection.data.message;
        }
        $location.path('/404');
      }
      return $q.reject(rejection);
    }

  }

})();


(function() {
    'use strict';

    angular
        .module('respondentClient')
        .factory('alertsFactory', alertsFactory);

    function alertsFactory($translate, toaster) {
        var alertsFactory = {
            remove: remove,
            show: show
        };

        return alertsFactory;

        function show(element, typeOfAlert) {
            var type = typeOfAlert || 'error';

            switch (type) {
                case 'error':
                    var translateParams = _prepareParamsTranslate(element.validator.message);
                    
                    $translate(element.validator.message.value, translateParams).then(function(translateValue) {
                        element.validator.toastInstance = toaster.pop({
                            type: 'error',
                            body: translateValue,
                            showCloseButton: true,
                            toasterId: element.data.id,
                            preventDuplicates: true,
                            onShowCallback: function() {
                                element.validator.showAlert = true;
                            },
                            onHideCallback: function() {
                                element.validator.showAlert = false;
                            }
                        });
                    });
                    break;
                case 'success':
                    $translate(element.message, translateParams).then(function(translateValue) {
                        toaster.pop({
                            type: type,
                            body: translateValue,
                            preventDuplicates: true,
                            tapToDismiss: false,
                            toasterId: 1
                        });
                    });
                    break;
                case 'warning':
                    $translate(element.message, translateParams).then(function(translateValue) {
                        toaster.pop({
                            type: type,
                            body: translateValue,
                            preventDuplicates: true,
                            toasterId: 2,
                            showCloseButton: true
                        });
                    });
                    break;
                case 'mandatoryAccess':
                    $translate(element.message, translateParams).then(function(translateValue) {
                        element.validator.toastInstance = toaster.pop({
                            type: 'error',
                            body: translateValue,
                            showCloseButton: true,
                            toasterId: element.target,
                            preventDuplicates: true,
                            onShowCallback: function() {
                                element.validator.showAlert = true;
                            },
                            onHideCallback: function() {
                                element.validator.showAlert = false;
                            }
                        });
                    });

                    break;
            }

            return element;
        }

        function remove(element) {
            if (element.validator.toastInstance) {
                toaster.clear(element.validator.toastInstance.toasterId, element.validator.toastInstance.toastId);
                element.validator.showAlert = false;
            }

            return element;
        }

        function _prepareParamsTranslate(element) {
            var translateParams = {};

            if (element.params != undefined) {
                if (element.params.minResponses != undefined) {
                    translateParams.minResponses = element.params.minResponses;
                }

                if (element.params.maxResponses != undefined) {
                    translateParams.maxResponses = element.params.maxResponses;
                }
            }

            if (element.message) {
                translateParams.message = element.message;
            }

            return translateParams;
        }
    }
})();
(function() {
    'use strict';

    // Notez que pour utiliser le stockage local, vous devez passer ngCookies dépendance à votre module,
    // Parce que si le stockage local n'est pas disponible, le module va utiliser le stockage de cookies
    angular
        .module('respondentClient')
        .config(config);

    function config($translateProvider) {
        $translateProvider.translations('en', {
                ADD_COMMENT: "Add comment",
                AFTER_SCALE: "After",
                AUTHENTIFICATION_ERROR: "AUTHENTIFICATION_ERROR",
                BEFORE_SCALE: "Before",
                CONDITIONAL_QUESTION_MSG: "CONDITIONAL_QUESTION_MSG",
                DETAILS_MEASURES: "Details of measures",
                ERROR_REGISTER: "The answers could not be saved, please try again later",
                EVALUATION_NOT_EXIST: "The evaluation does not exist",
                EVALUATION_OUT_DATED: "The evaluation period is closed. You can no longer answer your questionnaire",
                FILL_COMMENT_HERE: "Enter your comment here...",
                FILL_TEXT_HERE: "Enter your text here...",
                INFORMATION_QUESTION_ASSOCIATE: "INFORMATION_QUESTION_ASSOCIATE",
                INFORMATION_QUESTION_ORDERLY_RESPONSE: "You can drag choices to change their order",
                LATEST_UPDATE: "Latest update",
                MSG_MAX_CHECK: "Please select {{maxResponses}} answer(s) to a maximum",
                MSG_MIN_CHECK: "Please select {{maiResponses}} answer(s) to a minimum",
                MSG_NOT_BLANK: "The answer to this question can't be empty",
                MSG_CHARACTER_NO_UNICODE: "Unicode characters are not allowed",
                MSG_QUESTION_FORGOTTEN: 'MSG_QUESTION_FORGOTTEN',
                MSG_VALUE_IS_REQUIRED: "The answer to this question is required",
                NEXT_STEP: "Next step",
                NEXT: "Next",
                NEXT_SURVEY: "Next survey",
                PAGE_NOT_FOUND: "This page is not found",
                PREVIOUS_STEP: "Previous step",
                PREVIOUS_SURVEY: "Previous survey",
                PRIVACY: "Privacy",
                REMOVE_COMMENT: "Remove comment",
                REQUEST_ERROR: "Connexion error",
                SEND: "Send",
                SESSION: "Session:",
                SESSION_ANALYSIS: "Group:",
                SORRY: "Sorry !",
                SUCCESS_REGISTER: "Your rating is complete, your answers have been correctly saved, you can close this page.",
                TERMINATE: "Validate",
                TERMS_OF_USE: "Terms of use",
                TRAINERS: "Trainer(s):",
                TRAINING: "Training:",
                TRAINING_ANALYSIS: "Diagnosis of needs:",
                USER_HAVE_ANSWRED: "This user has already answered this evaluation",
                USER_IS_ABSENT: "This user is absent for this evaluation",
                EXPLAIN_ACCESS: "Vous souhaitez participer à l'évaluation {{measure_name}} destinée aux participants de la formation {{training_name}}",
                EXPLAIN_MODUS_ALL: "Merci de renseigner les informations ci-dessous ou de cliquer directement sur le bouton \"suivant\" pour répondre directement",
                EXPLAIN_MODUS_MANDATORY: "Merci de renseigner les informations ci-dessous",
                EXPLAIN_MODUS_REGISTER_ONLY: "Merci de renseigner les informations ci-dessous afin de vous connecter",
                YOUR_FNAME: "Indiquez votre prénom",
                YOUR_LNAME: "Indiquez votre nom de famille",
                YOUR_EMAIL: "Indiquez votre courriel",
                SUCCESS_REGISTER_USER: "Votre inscription a bien été prise en compte, vous allez être redirigé vers votre évaluation",
                ERROR_REGISTER_USER: "Votre inscription n'a pu être validée",
                ERROR_REGISTER_NAME: "The firstname and lastname you have filled in don't match",
                ERROR_GET_SURVEYHASH: "Access failed to the template",
                FNAME_IS_MANDATORY: "Firstname is mandatory",
                LNAME_IS_MANDATORY: "Lastname is mandatory",
                EMAIL_IS_MANDATORY: "Email is mandatory",
                WELCOME: "Welcome"
            })
            .translations('fr', {
                ADD_COMMENT: "Ajouter un commentaire",
                AFTER_SCALE: "Après",
                AUTHENTIFICATION_ERROR: "erreur de connexion",
                BEFORE_SCALE: "Avant",
                CONDITIONAL_QUESTION_MSG: "Vous avez répondu « {{response}} » à la question « {{title}} ». Répondez au questionnaire suivant.",
                DETAILS_MEASURES: "Détails de l'évaluation",
                ERROR_REGISTER: "Les réponses n'ont pu être correctement enregistrées, veuillez réessayer ultérieurement",
                EVALUATION_NOT_EXIST: "L'évaluation n'existe pas",
                EVALUATION_OUT_DATED: "La période d'évaluation est clôturée. Vous ne pouvez plus répondre à votre questionnaire.",
                FILL_COMMENT_HERE: "Renseignez votre commentaire ici...",
                FILL_TEXT_HERE: "Renseignez votre texte ici...",
                INFORMATION_QUESTION_ASSOCIATE: "Pour relier 2 éléments, cliquez sur un élément puis sur l’autre. Pour effacer un lien, cliquez dessus.",
                INFORMATION_QUESTION_ORDERLY_RESPONSE: "Faites glisser les éléments pour les mettre dans le bon ordre.",
                LATEST_UPDATE: "Dernière mise à jour",
                MSG_MAX_CHECK: "Veuillez choisir {{maxResponses}} réponse(s) au maximum",
                MSG_MIN_CHECK: "Veuillez choisir {{minResponses}} réponse(s) au minimum",
                MSG_NOT_BLANK: "La réponse à cette question ne doit pas être vide",
                MSG_CHARACTER_NO_UNICODE: "Les caractères unicode ne sont pas autorisés",
                MSG_QUESTION_FORGOTTEN: 'MSG_QUESTION_FORGOTTEN',
                MSG_VALUE_IS_REQUIRED: "La réponse de cette question est obligatoire",
                NEXT_STEP: "Page",
                NEXT_SURVEY: "Questionnaire",
                NEXT: "Suivant",
                PAGE_NOT_FOUND: "Cette page est introuvable",
                PREVIOUS_STEP: "Page",
                PREVIOUS: "Précédent",
                PRIVACY: "Confidentialité",
                REMOVE_COMMENT: "Supprimer le commentaire",
                REQUEST_ERROR: "Erreur de connexion",
                SEND: "Envoyer",
                SESSION: "Session :",
                SESSION_ANALYSIS: "Groupe :",
                SORRY: "Désolé !",
                SUCCESS_REGISTER: "Votre évaluation est terminée, vos réponses ont été correctement enregistrées, vous pouvez fermer cette page.",
                TERMINATE: "Valider",
                TERMS_OF_USE: "Conditions générales",
                TRAINERS: "Formateur(s) :",
                TRAINING: "Formation :",
                TRAINING_ANALYSIS: "Diagnostic des besoins :",
                USER_HAVE_ANSWRED: "Cet utilisateur a déjà répondu à cette évaluation",
                USER_IS_ABSENT: "Cet utilisateur est absent à cette évaluation",
                EXPLAIN_ACCESS: "Vous souhaitez participer à l'évaluation {{measure_name}} destinée aux participants de la formation {{training_name}}",
                EXPLAIN_MODUS_ALL: "Merci de renseigner les informations ci-dessous ou de cliquer directement sur le bouton \"suivant\" pour répondre directement",
                EXPLAIN_MODUS_REGISTRATION_REQUIRED: "Merci de renseigner les informations ci-dessous",
                EXPLAIN_MODUS_REGISTER_ONLY: "Merci de renseigner les informations ci-dessous afin de vous connecter",
                YOUR_FNAME: "Indiquez votre prénom",
                YOUR_LNAME: "Indiquez votre nom de famille",
                YOUR_EMAIL: "Indiquez votre courriel",
                SUCCESS_REGISTER_USER: "Votre inscription a bien été prise en compte, vous allez être redirigé vers votre évaluation",
                ERROR_REGISTER_USER: "Votre inscription n'a pu être validée",
                ERROR_REGISTER_NAME: "Le prénom et le nom que vous avez indiqués ne correspondent pas",
                ERROR_GET_SURVEYHASH: "Échec de votre accès au questionnaire",
                FNAME_IS_MANDATORY: "Le prénom est obligatoire",
                LNAME_IS_MANDATORY: "Le nom de famille est obligatoire",
                EMAIL_IS_MANDATORY: "Le courriel est obligatoire",
                WELCOME: "Bienvenue"
            });

        // la langue utilisée par défaut
        // configuration.languages.default
        $translateProvider.preferredLanguage('fr');

        // stocker la langue dans le stockage local
        $translateProvider.useLocalStorage();

        // permet d'enlever l'erreur en console -  warning: security
        $translateProvider.useSanitizeValueStrategy('escape');
    }
})();

(function () {
    'use strict';
    angular.module('respondentClient')
        .directive('sliderQuestion', function ($filter, configuration) {
            return {
                restrict: 'E',
                scope: {
                    options: '=',
                    element: '='
                },
                replace: true,
                transclude: true,
                templateUrl: "app/views/directives/library/slider-question.html",
                controller: sliderController,
                controllerAs: 'vm',
                bindToController: true
            };


            function sliderController($scope) {
                var vm = this;
                var modelLabels = {};

                __init(vm);

                modelLabels[parseInt(vm.options.from)] = vm.options.labels[0];
                modelLabels[parseInt(vm.options.to)] = vm.options.labels[1];

                vm.sliderOptions = [];
                vm.sliderOptions[vm.options.id] = {
                    from: parseInt(vm.options.from),
                    to: parseInt(vm.options.to),
                    floor: true,
                    step: 1,
                    vertical: false,
                    smooth: false,
                    realtime: true,
                    css: {
                        background: {"background-color": configuration.sliderColors.background},
                        before: {"background-color": configuration.sliderColors.before},
                        after: {"background-color": configuration.sliderColors.after},
                        pointer: {"background-color": configuration.sliderColors.pointer}
                    },
                    scale: vm.options.scales,
                    modelLabels: modelLabels,
                    callback: function (value) {

                        if (vm.element.response == undefined || vm.element.response == -1) {

                            vm.element.response = {};
                        }



                        var countResponses = null;
                        switch (parseInt(vm.element.data.type)) {

                            case 2:
                                var responseBefore = vm.element.response[vm.element.data.id + '-before'];
                                var responseAfter = vm.element.response[vm.element.data.id + '-after'];

                                if (responseBefore != undefined && responseAfter != undefined) {
                                    vm.element.haveChoiceResponse = true;
                                }
                                $scope.$apply(function () {
                                    vm.element.response[vm.options.id] = value;
                                });
                                break;

                            case 9 :
                            case 10 :
                                var type = 'objective';
                                if (parseInt(vm.element.data.type) == 9) {
                                    type = 'commitment';
                                }
                                var objectives = $filter('filter')(vm.element.data.objects, {type: type});
                                var questionObject = $filter('filter')(vm.element.data.objects, {type: 'parameter'});
                                var isBeforeAfter = questionObject[0].data.beforeAfter;
                                countResponses = Object.keys(vm.element.response).length;
                                var countObjectives = objectives.length;
                                vm.element.haveChoiceResponse = false;

                                // validation avant/après

                                if (isBeforeAfter) {

                                    countObjectives = objectives.length * 2;
                                    if (vm.element.response != undefined && countObjectives == countResponses) {
                                        vm.element.haveChoiceResponse = true;
                                    }
                                    $scope.$apply(function () {
                                        vm.element.response[vm.options.id] = value;
                                    });
                                }
                                else {
                                    if (countResponses == countObjectives) {
                                        vm.element.haveChoiceResponse = true;
                                    }
                                    vm.element.response[parseInt(vm.options.id)] = value;
                                    $scope.$apply(function () {
                                        vm.element.response[parseInt(vm.options.id)] = value;
                                    });
                                }
                                break;
                            case 18:
                                var sequences = $filter('filter')(vm.element.data.objects, {type: 'sequence'});
                                countResponses = Object.keys(vm.element.response).length;
                                var countSequences = sequences.length;
                                vm.element.haveChoiceResponse = false;

                                if (countResponses == countSequences) {
                                    vm.element.haveChoiceResponse = true;
                                }
                                vm.element.response[parseInt(vm.options.id)] = value;
                                $scope.$apply(function () {
                                     vm.element.response[parseInt(vm.options.id)] = value;
                                });
                                break;
                            case 12:
                                var trainers = $filter('filter')(vm.element.data.objects, {type: 'trainer'});
                                countResponses = Object.keys(vm.element.response).length;
                                var countTrainers = trainers.length;
                                vm.element.haveChoiceResponse = false;

                                if (countResponses == countTrainers) {
                                    vm.element.haveChoiceResponse = true;
                                }
                                vm.element.response[parseInt(vm.options.id)] = value;
                                $scope.$apply(function () {
                                    vm.element.response[parseInt(vm.options.id)] = value;
                                });
                                break;
                            default:
                                if (vm.element.response != -1) {
                                    vm.element.haveChoiceResponse = true;
                                }
                                vm.element.response[parseInt(vm.options.id)] = value;
                                break;
                        }

                        if (parseInt(vm.element.data.type) != 2 && parseInt(vm.element.data.type) != 9 && parseInt(vm.element.data.type) != 10
                            && parseInt(vm.element.data.type) != 12 && parseInt(vm.element.data.type) != 18) {
                            $scope.$apply(function () {
                                vm.element.response[parseInt(vm.options.id)] = value;
                            });
                        }

                    }

                };

            }

            function __init(vm) {
                var elementParameters = $filter('filter')(vm.element.data.objects, {type: 'parameter'});
                vm.element.mandatory = elementParameters[0].data.nonActivable;
                vm.element.doesntAnswerInputLabel = elementParameters[0].data.nonActivableLabel;
                vm.element.commentable = elementParameters[0].data.commentable;
            }

        });
})();

(function () {
    'use strict';

    angular
        .module('respondentClient')
        .controller('CheckServicesController', CheckServicesController);

    /** @ngInject */
    function CheckServicesController($stateParams, checkservicesService) {

        var vm = this;

        /**
         * Appel au constructor
         */
        __construct();
        /**
         *
         * @private
         */
        function __construct() {

            vm.response = "OK";
            if($stateParams.callapi) {
                checkservicesService.get().then(function (response) {

                    if(response.status != 200 || response.statusText != "OK") {
                        vm.response = "Api response not OK"
                    }
                }).catch(function () {
                    vm.response = "Api communication not OK"
                });
            }
        }
    }
})();

(function() {
    'use strict';
    angular.module('respondentClient')
        .directive('autoComplete', autoComplete);

    function autoComplete() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                input: '=',
                placeholder: '@',
                source: '='
            },
            templateUrl: "app/views/autoComplete/auto-complete.html",
            controller: 'AutoCompleteController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('respondentClient')
        .controller('AutoCompleteController', AutoCompleteController);

    function AutoCompleteController($scope) {
        var vm = this;

        __initialize();

        function __initialize() {
            // Bloodhound is the typeahead.js suggestion engine
            var bloodhound = new Bloodhound({
                datumTokenizer: function(d) { return Bloodhound.tokenizers.whitespace(d.text); },
                queryTokenizer: Bloodhound.tokenizers.whitespace
            });

            bloodhound.initialize();

            vm.bloodhoundDataset = {
                displayKey: 'text',
                source: bloodhound.ttAdapter()
            };

            /**
             * @description Add new sources to bloodhound
             */
            $scope.$watch('vm.source', function () {
                if(angular.isDefined(vm.source)) {
                    bloodhound.clear();
                    vm.source.forEach(function(firstName) {
                        bloodhound.add({'text': firstName});
                    });
                }
            }, true);
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('respondentClient')
    .controller('404Controller', errorController);

  function errorController(localStorageFactory) {
    var vm = this;

    __initialize();

    function __initialize() {
      var urlLogoOrganisation = localStorageFactory.get('urlLogoOrganisation');
      if(urlLogoOrganisation !== null) {
        vm.logo = urlLogoOrganisation;
      } else {
        vm.logo = "/assets/images/formaevaV2.png";
      }
    }
  }
})();

/**
 * path/css : /app/ en mode développement
 *          : /styles/ en mode production
 */
/**
 * path/css : /app/ en mode développement
 *          : /styles/ en mode production
 */
(function () {
  'use strict';

  angular
    .module('respondentClient')
    .constant('configuration', {
      "server_name": "api.fmva-meso.net",
      "prefix_org": window.location.hash.split('/')[window.location.hash.split('/').length - 1],
      "protocol_type": window.location.protocol || "https",
      "server_name_orgs": "assets.fmva-meso.com/org/",
      "path": {
        css: '/app/'
      },
      "scrollParameter": {
        'offsets': 30,
        'duration': 500
      },
      "templatesForOrganizations": {
        'opcalia': 'opcalia',
        'opcalia-pdl': 'opcalia',
        'opcalia-bqa': 'opcalia',
        'opcalia-prodiat': 'opcalia',
        'default': 'formaeva'
      },
      "sliderColors": {
        background: "#cdd200",
        before: "#7ca121",
        after: "#7ca121",
        pointer: "#989898"
      }
    });

})();

(function() {
	'use strict';

	angular
		.module('respondentClient')
		.run(initialize);

	function initialize($rootScope, initTemplateFactory, $css) {
		var cssToInject = initTemplateFactory.getCssFileToInject();
		$css.add(cssToInject);

		$rootScope.messageError = 'PAGE_NOT_FOUND';
		$rootScope.connected = true;
	}
})();

(function() {
    'use strict';
    angular
        .module('respondentClient')
        .config(routerConfig);

    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home', {
                url: '/surveys/:surveyHash/:organization',
                templateUrl: 'app/views/surveys/surveys.html',
                controller: 'SurveysController',
                controllerAs: 'vm',
                resolve: {
                    initSurvey: ['$stateParams', function($stateParams) {
                        return $stateParams.surveyHash;
                    }]
                }
            }).state('register', {
                url: '/users/register/:surveyHash/:organization',
                templateUrl: 'app/views/users/register.html',
                controller: 'RegisterFormController',
                controllerAs: 'vm',
                resolve: {
                    initSurvey: ['$stateParams', function($stateParams) {
                        return $stateParams.surveyHash;
                    }]
                }
            }).state('checkservices', {
                url: '/checkservices/:callapi?',
                templateUrl: 'app/views/checkservices/index.html',
                controller: 'CheckServicesController',
                controllerAs: 'vm',
                resolve: {
                }
            }).state('404', {
                url: '/404',
                templateUrl: 'app/views/404.html',
                controller: '404Controller',
                controllerAs: 'vm'
            });

        $urlRouterProvider.otherwise('/404');
    }
})();

(function() {
  'use strict';

  angular
    .module('respondentClient')
    .config(config);

  /** @ngInject */
  function config($httpProvider) {
    // voir avec Hatem car plantage des tests lorsque passage du cssInjectorProvider
    // function config($httpProvider, cssInjectorProvider)

    $httpProvider.interceptors.push('httpInterceptorFactory');
    $httpProvider.defaults.cache = false;
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }
    // disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';

    $httpProvider.defaults.headers.common['Accept'] = 'application/json';
    $httpProvider.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
    $httpProvider.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
    $httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    $httpProvider.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS, HEAD';

    //cssInjectorProvider.setSinglePageMode(true);
  }

})();

angular.module("respondentClient").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/404.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-offset-1 col-sm-10\"><ng-include src=\"\'app/views/partials/header.html\'\"></ng-include><div class=\"content\"><div class=\"not-found col-sm-12\">{{ \'SORRY\' | translate}} {{ $root.messageError | translate}}</div><div class=\"clearfix\"></div></div></div></div></div>");
$templateCache.put("app/views/autoComplete/auto-complete.html","<input ng-model=\"vm.input\" type=\"text\" sf-typeahead=\"\" datasets=\"vm.bloodhoundDataset\" class=\"input-form\" placeholder=\"{{vm.placeholder}}\"><br>");
$templateCache.put("app/views/checkservices/index.html","{{vm.response}}");
$templateCache.put("app/views/partials/content.html","<div class=\"content\"><ng-include src=\"\'app/views/partials/summary.html\'\"></ng-include></div><div class=\"content\" ng-if=\"vm.surveysFormatted.surveys.length > 0\"><survey surveys=\"vm.surveysFormatted.surveys\" parameters=\"vm.parameters\" summary=\"vm.surveysFormatted.summary\"></survey></div>");
$templateCache.put("app/views/partials/footer.html","<footer><section><a target=\"_blank\" href=\"http://www.formaeva.com\">&copy; Formæva</a> • {{ \'LATEST_UPDATE\' | translate}} 11-10-2016 <a target=\"_blank\" href=\"http://www.formaeva.com/conditions-generales-utilisation-fr.html\">{{ \'TERMS_OF_USE\' | translate}}</a> <span>-</span> <a target=\"_blank\" href=\"http://www.formaeva.com/politique-de-confidentialite-fr.html\">{{ \'PRIVACY\' | translate}}</a></section></footer>");
$templateCache.put("app/views/partials/header.html","<header><a href=\"/\"><img ng-show=\"vm.logo\" border=\"0\" ng-src=\"{{vm.logo}}\"></a></header>");
$templateCache.put("app/views/partials/summary.html","<section class=\"summary\"><h1>{{vm.surveysFormatted.summary.labelsForSummary.TrainingLabel | translate}}</h1><h2>{{vm.surveysFormatted.summary.trainingTitle}}</h2><p><strong>{{vm.surveysFormatted.summary.labelsForSummary.sessionLabel | translate}}</strong> {{vm.surveysFormatted.summary.sessionTitle}}<br><strong ng-if=\"vm.surveysFormatted.summary.trainers.length > 0\">{{\'TRAINERS\' | translate}}</strong><br><span ng-repeat=\"trainingOrganization in vm.surveysFormatted.summary.trainers\">{{trainingOrganization.title}}<span ng-if=\"trainingOrganization.trainers.length > 0\">- {{trainingOrganization.trainers.join(\', \')}}</span><br></span></p></section>");
$templateCache.put("app/views/surveys/surveys.html","<div class=\"loading\" ng-show=\"vm.loading\"><img src=\"/assets/images/loading.gif\"></div><div ng-show=\"!vm.loading\"><div class=\"col-xs-12 col-sm-12 col-md-offset-2 col-md-8\"><ng-include src=\"\'app/views/partials/header.html\'\"></ng-include><ng-include ng-show=\"!vm.loading\" src=\"\'app/views/partials/content.html\'\"></ng-include></div></div>");
$templateCache.put("app/views/users/register.html","<registercontent><div class=\"row\"><div class=\"col-sm-offset-1 col-sm-10\"><ng-include src=\"\'app/views/partials/header.html\'\"></ng-include><div class=\"content\"><div id=\"content_login\" class=\"contentLogin\"><nav class=\"primaryMenuLogin\"></nav><registerform></registerform><div class=\"clearfix\"></div></div></div></div></div></registercontent>");
$templateCache.put("app/views/directives/library/slider-question.html","<div class=\"slider\"><div class=\"does-not-answer\"><does-not-answer ng-if=\"vm.element.mandatory == 1 && vm.element.showDoesNotAnswerByScale\" label=\"vm.element.doesntAnswerInputLabel\" element=\"vm.element\" disabled=\"vm.options.id\"></does-not-answer></div><div class=\"slider-content\" ng-class=\"{\'default-pointer\': vm.element.response == null || vm.element.response == -1 ,\'selected-pointer\':vm.element.response[vm.options.id] != null}\"><input ng-model=\"vm.options.model\" ng-disabled=\"vm.element.doesntAnswerInputChecked[vm.options.id] == true\" type=\"text\" id=\"{{vm.options.id}}\" slider=\"\" options=\"vm.sliderOptions[vm.options.id]\"></div><comment-by-scale ng-if=\"vm.element.commentable == 1 && vm.element.showCommentByScale\" element=\"vm.element\" id=\"vm.options.id\"></comment-by-scale></div>");
$templateCache.put("app/views/directives/questionnaire/page.html","<element ng-repeat=\"element in vm.page\" element=\"element\"></element>");
$templateCache.put("app/views/directives/questionnaire/questionnaire.html","<div class=\"questionnaire\"><div class=\"alert-container-message\" ng-show=\"vm.finalMessageValidation.success == true\"><toaster-container toaster-options=\"{\'toaster-id\': 1,\'time-out\': 0,\'position-class\': \'toast-top-full-width\',\'limit\':1}\"></toaster-container></div><toaster-container toaster-options=\"{\'toaster-id\': 2,\'time-out\': 0,\'limit\':1}\"></toaster-container><div ng-show=\"!vm.finalMessageValidation.success\"><div class=\"waiting\" ng-if=\"vm.waitingForConditionalSurveys\"></div><div ng-show=\"vm.conditionalQuestionsMessage\" class=\"info\">{{\'CONDITIONAL_QUESTION_MSG\' | translate:vm.conditionalQuestionsMessage}}</div><h2>{{vm.surveys[vm.currentSurveysIndex].name}}</h2><form name=\"responsesForm\"><page page=\"vm.currentPage\"></page></form><div class=\"pagination\"><div class=\"md-l-responsive\"><a href=\"\" class=\"f-left previous\" ng-click=\"vm.before()\" ng-if=\"(vm.currentPageIndex != 0 || (vm.currentSurveysIndex != 0 && vm.surveys[vm.currentSurveysIndex -1].answered == 0))\"><i class=\"icon_previous\"></i> {{vm.previewsBtnTxt | translate}}</a> <a href=\"\" class=\"f-right next\" ng-click=\"vm.next()\" ng-if=\"!vm.lastPageInLastSurveys\"><i class=\"icon_next\"></i> {{vm.nextBtnTxt | translate}}</a> <a href=\"\" class=\"f-right valid\" ng-click=\"vm.terminate()\" ng-hide=\"vm.flagIsValidate\" ng-if=\"vm.lastPageInLastSurveys\"><i class=\"icon_valid\"></i> {{\'TERMINATE\' | translate}}</a></div><div class=\"xs-responsive\"><a href=\"\" class=\"f-left\" ng-click=\"vm.before()\" ng-if=\"(vm.currentPageIndex != 0 || vm.currentSurveysIndex != 0 && (vm.currentSurveysIndex != 0 && vm.surveys[vm.currentSurveysIndex -1].answered == 0))\"><i class=\"icon_mobile_previous\"></i></a> <a href=\"\" class=\"f-right\" ng-click=\"vm.next()\" ng-if=\"!vm.lastPageInLastSurveys\"><i class=\"icon_mobile_next\"></i></a> <a href=\"\" class=\"f-right\" ng-click=\"vm.terminate()\" ng-hide=\"vm.flagIsValidate\" ng-if=\"vm.lastPageInLastSurveys\"><i class=\"icon_mobile_valid\"></i></a></div><div class=\"clearfix\"></div></div></div></div>");
$templateCache.put("app/views/partials/register/header.html","<header></header>");
$templateCache.put("app/views/partials/register/registerform.html","<div id=\"form_login\" class=\"form-login\" infos=\"vm.infos\" style=\"position: relative\"><div class=\"alert-container-message\" ng-show=\"vm.finalMessageValidation.success == true\"><toaster-container toaster-options=\"{\'toaster-id\': 1,\'time-out\': 0,\'position-class\': \'toast-top-full-width\',\'limit\':1}\"></toaster-container></div><div class=\"moduleTitleLogin\" ng-show=\"vm.finalMessageValidation.success == false\"><h3 class=\"title-login\">{{ \'WELCOME\' | translate}}</h3><p class=\"title-explain-measure\">{{ \'EXPLAIN_ACCESS\' | translate}}</p><p class=\"title-explain-modus\">{{ vm.EXPLAIN_MODUS | uppercase | translate}}</p></div><form name=\"loginForm\" ng-show=\"vm.finalMessageValidation.success == false\"><table id=\"table_login\" class=\"login-inputs\"><tr><td><div class=\"td-mandatory-field\"><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': \'fname\',\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><auto-complete ng-show=\"vm.infos.data.measureAccess == \'register_only\'\" input=\"vm.inputs.fname.value\" id=\"fname\" name=\"fname\" ng-attr-placeholder=\"{{ \'YOUR_FNAME\' | translate}}\" source=\"vm.firstnames\"></auto-complete><input ng-show=\"vm.infos.data.measureAccess != \'register_only\'\" type=\"text\" class=\"input-form\" ng-model=\"vm.inputs.fname.value\" id=\"fname\" name=\"fname\" placeholder=\"{{ \'YOUR_FNAME\' | translate}}\" source=\"vm.firstnames\"></div></td></tr><tr><td><div class=\"td-mandatory-field\"><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': \'lname\',\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><auto-complete ng-show=\"vm.infos.data.measureAccess == \'register_only\'\" input=\"vm.inputs.lname.value\" id=\"lname\" name=\"lname\" placeholder=\"{{ \'YOUR_LNAME\' | translate}}\" source=\"vm.lastnames\"></auto-complete><input ng-show=\"vm.infos.data.measureAccess != \'register_only\'\" type=\"text\" class=\"input-form\" ng-model=\"vm.inputs.lname.value\" id=\"lname\" name=\"lname\" placeholder=\"{{ \'YOUR_LNAME\' | translate}}\" source=\"vm.lastnames\"> </></div></td></tr><tr ng-show=\"vm.infos.data.measureAccess != \'register_only\'\"><td><div class=\"td-mandatory-field\"><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': \'email\',\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><input ng-model=\"vm.inputs.email.value\" type=\"email\" id=\"email\" name=\"email\" class=\"input-form\" placeholder=\"{{ \'YOUR_EMAIL\' | translate}}\"><br></div></td></tr><tr><td><button id=\"register\" type=\"submit\" class=\"btn-login\" ng-click=\"vm.register()\">{{ \'NEXT\' | translate}}</button></td></tr></table></form><div class=\"alert-container-message\" ng-show=\"vm.finalMessageValidation.error == true\"><toaster-container toaster-options=\"{\'toaster-id\': 2, \'time-out\': 0, \'position-class\': \'toast-bottom-full-width\', \'limit\':1}\"></toaster-container></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/does-not-answer.html","<div class=\"mandatory\"><div class=\"checkboxDoesntAnswer\"><input class=\"checkboxDoesntAnswer\" name=\"input-checkboxDoesntAnswer\" type=\"checkbox\" ng-model=\"vm.element.doesntAnswerInputChecked[vm.disabled]\"> <label class=\"control-label\">{{vm.label}}</label></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/objectivesList-element.html","<div><div class=\"objectivesListTitle\">{{element.data.title}}</div><ul ng-repeat=\"objective in element.data.objects\"><li>{{objective.data.title}}</li></ul></div>");
$templateCache.put("app/views/directives/questionnaire/elements/section-element.html","<section ng-bind-html=\"element.data.title\" class=\"section-element\"></section>");
$templateCache.put("app/views/directives/questionnaire/elements/text-element.html","<section ng-transclude=\"\" ng-bind-html=\"element.data.content\" class=\"text-element\"></section>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/associative.html","<div><p id=\"informationsAssociative\"><i class=\"icon_information\"></i> {{\'INFORMATION_QUESTION_ASSOCIATE\' | translate}}</p><toaster-container toaster-options=\"{\'time-out\': 0, \'toaster-id\': {{vm.element.data.id}}, \'animation-class\': \'toast-top-rigth\', \'limit\': 1}\"></toaster-container><div><div class=\"question-associative\"><div ng-class=\"{true: \'disabled\'}[vm.element.doesntAnswerInputChecked[vm.questionId]]\"><ul id=\"leftList\" class=\"f-left width30\"><li ng-repeat=\"ele in vm.choices | filter: {float: \'left\'}\" ng-click=\"vm.drawLeft($event, ele.id)\" ng-class=\"{active: ele.id == vm.selectedLeftItem}\" id=\"ele-{{ele.id}}\">{{ele.title}}</li></ul><svg id=\"svg\" class=\"svgElement f-left\"><line id=\"{{$index}}\" ng-repeat=\"ele in vm.svgLines\" ng-if=\"(ele | countKeysObject) >= 5\" ng-attr-x1=\"{{ele.x}}\" ng-attr-y1=\"{{ele.y}}\" ng-attr-x2=\"{{ele.lx}}\" ng-attr-y2=\"{{ele.ly}}\" ng-click=\"vm.removeLine($index, ele)\"></line></svg><ul id=\"rightList\" class=\"f-left width30\"><li ng-repeat=\"ele in vm.choices | filter: { float: \'right\'} | groupById\" ng-click=\"vm.drawRight($event, ele.id)\" ng-class=\"{active: ele.id == vm.selectedrightItem}\" id=\"ele-{{ele.id}}\">{{ele.title}}</li></ul></div></div></div>{{vm.calculDifferenceBetweenChoices()}}<div class=\"clearfix\"></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/comment-by-scale.html","<div class=\"comment\"><div class=\"comment-head\"><span ng-show=\"!vm.showTextArea[vm.id]\" ng-click=\"vm.showTextArea[vm.id] = true\">{{ \'ADD_COMMENT\' | translate}}</span> <span ng-click=\"vm.showTextArea[vm.id] = false\" ng-show=\"vm.showTextArea[vm.id]\">{{ \'REMOVE_COMMENT\' | translate}}</span></div><div class=\"comment-body\" ng-if=\"vm.showTextArea[vm.id]\"><textarea rows=\"6\" id=\"comment-{{vm.id}}\" ng-model=\"vm.element.comment[vm.id]\" name=\"comment-{{vm.id}}\" placeholder=\"{{ \'FILL_COMMENT_HERE\' | translate}}\"></textarea></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/comment.html","<div class=\"comment\"><div class=\"comment-head\"><span ng-show=\"!vm.showTextArea[vm.element.data.id]\" ng-click=\"vm.showTextArea[vm.element.data.id] = true\">{{ \'ADD_COMMENT\' | translate}}</span> <span ng-click=\"vm.showTextArea[vm.element.data.id] = false\" ng-show=\"vm.showTextArea[vm.element.data.id]\">{{ \'REMOVE_COMMENT\' | translate}}</span></div><div class=\"comment-body\" ng-if=\"vm.showTextArea[vm.element.data.id]\"><textarea rows=\"6\" id=\"comment-{{vm.elementId}}\" ng-model=\"vm.element.comment[vm.elementId]\" name=\"comment-{{vm.questionId}}\" placeholder=\"{{\'FILL_COMMENT_HERE\' | translate}}\"></textarea></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/free-text.html","<div ng-show=\"$root.checkIfCondition[vm.element.data.id] == null || $root.checkIfCondition[vm.element.data.id]\"><toaster-container toaster-options=\"{\'time-out\': 0, \'toaster-id\': {{vm.element.data.id}}, \'animation-class\': \'toast-top-rigth\', \'limit\': 1}\"></toaster-container><div class=\"textarea\"><textarea ng-disabled=\"$root.currentSurveysIndex == 0 && $root.organizationPrefix == \'socotec\'\" rows=\"5\" id=\"free-text-{{vm.element.data.id}}\" name=\"free-text-{{vm.element.data.id}}\" ng-model=\"vm.element.response\" placeholder=\"{{ \'FILL_TEXT_HERE\' | translate}}\"></textarea></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/multi-choice.html","<div ng-model=\"countResponse\"><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div class=\"checkbox-group\"><div class=\"checkbox\" ng-repeat=\"choice in vm.choices\"><input type=\"checkbox\" value=\"{{choice.id}}\" name=\"input-{{vm.element.data.id}}\" ng-model=\"vm.element.response[choice.id]\" id=\"input-{{vm.element.data.id}}-{{choice.id}}\" ng-disabled=\"vm.element.doesntAnswerInputChecked[vm.questionId]\"> <label for=\"input-{{vm.element.data.id}}-{{choice.id}}\" class=\"control-label\">{{choice.title}}</label></div></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/ordered-response.html","<div><p><i class=\"icon_information\"></i> {{\'INFORMATION_QUESTION_ORDERLY_RESPONSE\' | translate}}</p><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><ul class=\"ordered-response\" data-as-sortable=\"vm.choiceSortOptions\" data-ng-model=\"vm.element.response\"><li data-ng-repeat=\"item in vm.choices\" data-as-sortable-item=\"\"><div ng-class=\"{true: \'disabled\'}[vm.element.doesntAnswerInputChecked[vm.questionId]]\"><span class=\"choice-ordered\" data-as-sortable-item-handle=\"\"><i>{{$index+1}}</i> {{item.data.title}}</span></div></li></ul></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/preference.html","<div><p><i class=\"icon_information\"></i> {{\'INFORMATION_QUESTION_ORDERLY_RESPONSE\' | translate}}</p><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><ul class=\"ordered-response\" data-as-sortable=\"vm.choiceSortOptions\" data-ng-model=\"vm.element.response\"><li data-ng-repeat=\"item in vm.choices\" data-as-sortable-item=\"\"><div ng-class=\"{true: \'disabled\'}[vm.element.doesntAnswerInputChecked[vm.questionId]]\"><span class=\"choice-ordered\" data-as-sortable-item-handle=\"\"><i>{{$index+1}}</i> {{item.data.title}}</span></div></li></ul></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/question.html","<div ng-show=\"vm.conditionDisplay || $root.checkIfCondition[vm.element.data.id]\"><div class=\"question-container\"><div id=\"{{vm.element.data.id}}\" class=\"question\">{{vm.element.data.title}}<does-not-answer ng-if=\"vm.mandatory == 1 && !vm.element.showDoesNotAnswerByScale && vm.element.data.type != 10\" label=\"vm.doesntAnswerInputLabel\" element=\"vm.element\" disabled=\"vm.element.data.id\"></does-not-answer><div class=\"questionType\"></div></div><comment ng-if=\"vm.commentable == 1 && !vm.element.showCommentByScale && vm.element.data.type != 10\" element=\"vm.element\"></comment></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/quizz.html","<div id=\"{{vm.element.data.id}}\" class=\"question\"><span>{{vm.element.data.title}}</span><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div class=\"checkbox-group\"><div class=\"checkbox\" ng-repeat=\"choice in vm.choices\"><input type=\"checkbox\" value=\"{{choice.id}}\" name=\"input-{{vm.element.data.id}}\" id=\"input-{{vm.element.data.id}}-{{choice.id}}\"> <label for=\"input-{{vm.element.data.id}}-{{choice.id}}\" class=\"control-label\">{{choice.title}}</label></div></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/scale-before-after.html","<div><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div><br><span class=\"title\">{{\'BEFORE_SCALE\' | translate }}</span><slider-question element=\"vm.element\" options=\"vm.sliderOptionsBefore\"></slider-question></div><div><br><span class=\"title\">{{\'AFTER_SCALE\' | translate }}</span><slider-question element=\"vm.element\" options=\"vm.sliderOptionsAfter\"></slider-question></div><br></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/scale-objectives-before-after.html","<div><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div ng-repeat=\"objective in vm.objectives\"><br><span>{{objective.title}}</span><does-not-answer ng-if=\"vm.nonActivable == 1\" label=\"vm.nonActivableLabel\" element=\"vm.element\" disabled=\"objective.id\"></does-not-answer><div><span class=\"title objectives\">{{\'BEFORE_SCALE\' | translate }}</span><slider-question element=\"vm.element\" options=\"vm.sliderOptions[objective.id][\'before\']\"></slider-question></div><div><br><span class=\"title\">{{\'AFTER_SCALE\' | translate }}</span><slider-question element=\"vm.element\" options=\"vm.sliderOptions[objective.id][\'after\']\"></slider-question></div><br><comment-by-scale ng-if=\"vm.element.commentable == 1\" element=\"vm.element\" id=\"vm.element.data.id + \'-\' + objective.id\"></comment-by-scale></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/scale-objectives.html","<div><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div class=\"objectives-scale\" ng-repeat=\"question in vm.questionData\"><div ng-show=\"vm.element.data.checkScaleisNull\" data=\"{{question.title.length}}\" ng-class=\"{\'mytest2\':(($last-1))}\"><span class=\"title objectives\" data-countindex=\"{{$index+1}}\">{{question.title}}</span></div><div ng-show=\"!vm.element.data.checkScaleisNull\"><span class=\"title objectives\" data-countindex=\"{{$index+1}}\">{{question.title}}</span></div><div ng-show=\"!vm.element.data.checkScaleisNull\"><slider-question element=\"vm.element\" options=\"vm.sliderOptions[question.id]\"></slider-question></div></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/scale-sequence.html","<div><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div ng-repeat=\"question in vm.questionData\"><br><span class=\"title sequences\">{{question.title}}</span><slider-question element=\"vm.element\" options=\"vm.sliderOptions[question.id]\"></slider-question><br></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/scale-trainer.html","<div><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div ng-repeat=\"question in vm.questionData\"><br ng-if=\"question.id != 0\"><span ng-if=\"question.id != 0\" class=\"title trainers\">{{question.title}}</span><slider-question element=\"vm.element\" options=\"vm.sliderOptions[question.id]\"></slider-question><br></div></div>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/scale.html","<toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><slider-question element=\"vm.element\" options=\"vm.sliderOptions\"></slider-question><br>");
$templateCache.put("app/views/directives/questionnaire/elements/questions/unique-choice.html","<div><toaster-container toaster-options=\"{\'time-out\': 0,\'toaster-id\': {{vm.element.data.id}},\'animation-class\': \'toast-top-rigth\',\'limit\':1}\"></toaster-container><div class=\"radio-group\"><div class=\"radio\" ng-repeat=\"choice in vm.choices\"><input type=\"radio\" value=\"{{choice.id}}\" name=\"input-{{vm.element.data.id}}\" ng-model=\"vm.element.response\" id=\"input-{{vm.element.data.id}}-{{choice.id}}\" ng-disabled=\"vm.element.doesntAnswerInputChecked[vm.element.data.id] || ($root.currentSurveysIndex == 0 && $root.organizationPrefix == \'socotec\')\"> <label for=\"input-{{vm.element.data.id}}-{{choice.id}}\" class=\"control-label\">{{choice.title}}</label></div></div></div>");}]);